import * as React from "react";
import { useState, useEffect } from "react";
import { Field, withTypes } from "react-final-form";
import axios from "axios";

import {
    Button,
    CircularProgress,
    TextField,
    Switch,
    FormControlLabel,
    Typography,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    InputAdornment,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    IconButton,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import SettingsIcon from "@material-ui/icons/Settings";
import MonetizationOnIcon from "@material-ui/icons/MonetizationOn";
import EmojiEventsIcon from "@material-ui/icons/EmojiEvents";
import PeopleIcon from "@material-ui/icons/People";
import WhatshotIcon from "@material-ui/icons/Whatshot";
import ScheduleIcon from "@material-ui/icons/Schedule";
import TrendingUpIcon from "@material-ui/icons/TrendingUp";
import EditIcon from "@material-ui/icons/Edit";
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";
import PhoneAndroidIcon from "@material-ui/icons/PhoneAndroid";
import BugReportIcon from "@material-ui/icons/BugReport";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import WarningIcon from "@material-ui/icons/Warning";
import RefreshIcon from "@material-ui/icons/Refresh";
import HistoryIcon from "@material-ui/icons/History";

import { Notification, useNotify } from "react-admin";
import { API } from "../Constant";
import { getConfigGet, getConfigPost, getConfigPatch } from "../getConfig";

const useStyles = makeStyles((theme) => ({
    main: {
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        padding: theme.spacing(3),
        backgroundColor: "#f5f5f5",
    },
    header: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: theme.spacing(3),
    },
    title: {
        fontWeight: 600,
    },
    accordion: {
        marginBottom: theme.spacing(1),
        "&:before": {
            display: "none",
        },
        overflow: "hidden",
    },
    accordionSummary: {
        backgroundColor: "#fafafa",
        borderBottom: "1px solid #e0e0e0",
    },
    sectionIcon: {
        marginRight: theme.spacing(1),
        color: theme.palette.primary.main,
    },
    sectionTitle: {
        fontWeight: 500,
    },
    sectionDescription: {
        color: theme.palette.text.secondary,
        fontSize: "0.875rem",
        marginLeft: theme.spacing(1),
    },
    fieldGrid: {
        display: "grid !important",
        gridTemplateColumns: "repeat(3, 1fr)",
        gap: "32px 24px !important",
        [theme.breakpoints.down('md')]: {
            gridTemplateColumns: "repeat(2, 1fr)",
        },
        [theme.breakpoints.down('sm')]: {
            gridTemplateColumns: "1fr",
        },
    },
    accordionDetails: {
        display: "block",
        overflow: "hidden",
        padding: theme.spacing(3),
        paddingRight: theme.spacing(4),
    },
    loadingContainer: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "50vh",
    },
    campaignSelect: {
        minWidth: 300,
        marginRight: theme.spacing(2),
    },
    headerActions: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(2),
    },
    tierTable: {
        marginTop: theme.spacing(2),
    },
    tierTableHeader: {
        backgroundColor: "#f5f5f5",
    },
    colorPreview: {
        width: 24,
        height: 24,
        borderRadius: 4,
        border: "1px solid #ccc",
        display: "inline-block",
        marginRight: theme.spacing(1),
    },
    statusBadge: {
        padding: "4px 12px",
        borderRadius: 12,
        fontSize: "0.75rem",
        fontWeight: 600,
    },
    statusActive: {
        backgroundColor: "#e8f5e9",
        color: "#2e7d32",
    },
    statusInactive: {
        backgroundColor: "#ffebee",
        color: "#c62828",
    },
    modeToggleSection: {
        padding: theme.spacing(3),
        backgroundColor: "#fff",
        borderRadius: 8,
        marginBottom: theme.spacing(2),
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
    },
    modeToggleInfo: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(2),
    },
    modeIcon: {
        fontSize: 40,
        color: theme.palette.primary.main,
    },
    // Prize Draw Screen Preview Styles
    screenPreviewContainer: {
        display: "flex",
        flexDirection: "row" as const,
        gap: theme.spacing(4),
        width: "100%",
        alignItems: "flex-start",
    },
    screenFormSection: {
        flex: "1 1 auto",
        minWidth: 0,
    },
    screenVariationSelect: {
        minWidth: 280,
        marginBottom: theme.spacing(3),
    },
    screenPreview: {
        flex: "0 0 320px",
        width: 320,
        background: "#FFAE00",
        borderRadius: 24,
        marginLeft: 12,
        boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
        overflow: "hidden",
        border: "8px solid #1a1a2e",
        fontFamily: "'PP Mori', 'PPMori', -apple-system, BlinkMacSystemFont, sans-serif",
        display: "flex",
        flexDirection: "column" as const,
        position: "relative" as const,
    },
    screenStatsRow: {
        display: "flex",
        justifyContent: "space-between",
        padding: "12px 16px 8px",
    },
    screenStatBox: {
        display: "flex",
        flexDirection: "column" as const,
    },
    screenStatLabel: {
        fontSize: 11,
        color: "#1a1a2e",
        marginBottom: 4,
        fontWeight: 500,
    },
    screenStatValue: {
        display: "flex",
        alignItems: "center",
        gap: 6,
        backgroundColor: "#1a1a2e",
        borderRadius: 20,
        padding: "6px 12px",
        color: "#fff",
        fontSize: 13,
        fontWeight: 600,
    },
    screenStatValueLight: {
        backgroundColor: "rgba(255,255,255,0.9)",
        borderRadius: 20,
        padding: "6px 12px",
        border: "2px solid #1a1a2e",
        color: "#1a1a2e",
        fontSize: 13,
        fontWeight: 600,
    },
    screenPastReferrals: {
        fontSize: 10,
        color: "#1a1a2e",
        marginTop: 4,
        opacity: 0.7,
    },
    // No Entry specific styles
    screenBadgeIcon: {
        width: 56,
        height: 56,
        borderRadius: "50%",
        backgroundColor: "#1a1a2e",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginBottom: 8,
        position: "relative" as const,
    },
    screenBadgeIconPlus: {
        position: "absolute" as const,
        bottom: 0,
        right: -4,
        width: 22,
        height: 22,
        borderRadius: "50%",
        backgroundColor: "#1a1a2e",
        border: "2px solid #FFAE00",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#FFAE00",
        fontSize: 14,
        fontWeight: 700,
    },
    screenBadgeText: {
        fontSize: 12,
        color: "#1a1a2e",
        marginBottom: 8,
        fontWeight: 500,
    },
    screenNoEntryContent: {
        display: "flex",
        flexDirection: "column" as const,
        alignItems: "center",
        padding: "24px 20px 8px",
        textAlign: "center" as const,
    },
    screenNoEntryTitle: {
        fontSize: 26,
        fontWeight: 700,
        color: "#1a1a2e",
        lineHeight: 1.15,
        marginBottom: 12,
        fontFamily: "'PP Mori', 'PPMori', -apple-system, BlinkMacSystemFont, sans-serif",
    },
    screenNoEntrySubtitle: {
        fontSize: 15,
        fontWeight: 600,
        color: "#1a1a2e",
        marginBottom: 6,
    },
    screenNoEntrySubtitle2: {
        fontSize: 13,
        color: "#1a1a2e",
        opacity: 0.8,
        lineHeight: 1.4,
        marginBottom: 8,
    },
    screenChestSection: {
        backgroundImage: "url('/pounds.svg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        minHeight: 180,
        width: "100%",
        position: "relative" as const,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    screenChestImage: {
        width: 160,
        height: "auto",
        filter: "drop-shadow(0 4px 8px rgba(0,0,0,0.2))",
    },
    screenWhiteCard: {
        backgroundColor: "#fff",
        borderTopLeftRadius: 24,
        borderTopRightRadius: 24,
        padding: "20px 16px",
        display: "flex",
        flexDirection: "column" as const,
        alignItems: "center",
        marginTop: -20,
        position: "relative" as const,
        zIndex: 1,
    },
    screenSecondaryCta: {
        display: "flex",
        alignItems: "center",
        gap: 6,
        fontSize: 14,
        color: "#1a1a2e",
        fontWeight: 500,
        marginBottom: 12,
    },
    screenMainContent: {
        display: "flex",
        flexDirection: "column" as const,
        alignItems: "center",
        padding: "16px 20px",
        textAlign: "center" as const,
    },
    screenTitle: {
        fontSize: 22,
        fontWeight: 700,
        color: "#1a1a2e",
        lineHeight: 1.2,
        marginBottom: 8,
        fontFamily: "'PP Mori', 'PPMori', -apple-system, BlinkMacSystemFont, sans-serif",
    },
    screenSubtitle: {
        fontSize: 13,
        color: "#1a1a2e",
        marginBottom: 12,
        opacity: 0.85,
        lineHeight: 1.4,
    },
    screenWinnerBanner: {
        display: "flex",
        alignItems: "center",
        gap: 8,
        backgroundColor: "rgba(255,255,255,0.9)",
        borderRadius: 20,
        padding: "8px 14px",
        marginBottom: 12,
        border: "2px solid #1a1a2e",
    },
    screenWinnerIcon: {
        width: 24,
        height: 24,
        borderRadius: "50%",
        backgroundColor: "#FFAE00",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: 12,
        border: "1.5px solid #1a1a2e",
    },
    screenWinnerText: {
        fontSize: 12,
        color: "#1a1a2e",
        fontWeight: 500,
    },
    screenCountdownInline: {
        display: "flex",
        alignItems: "baseline",
        gap: 4,
        marginBottom: 16,
    },
    screenCountdownUnit: {
        display: "flex",
        flexDirection: "column" as const,
        alignItems: "center",
    },
    screenCountdownLabel: {
        fontSize: 9,
        color: "#1a1a2e",
        textTransform: "uppercase" as const,
        opacity: 0.7,
        marginBottom: 2,
    },
    screenCountdownValue: {
        fontSize: 26,
        fontWeight: 700,
        color: "#1a1a2e",
    },
    screenCountdownSeparator: {
        fontSize: 26,
        fontWeight: 700,
        color: "#1a1a2e",
        marginLeft: 4,
        marginRight: 4,
    },
    screenBottomSection: {
        padding: "12px 16px 16px",
        backgroundColor: "#FFAE00",
        display: "flex",
        flexDirection: "column" as const,
        alignItems: "center",
    },
    screenCtaButton: {
        backgroundColor: "#1a1a2e",
        color: "#fff",
        borderRadius: 30,
        padding: "14px 24px",
        fontSize: 15,
        fontWeight: 600,
        width: "90%",
        textAlign: "center" as const,
        marginBottom: 8,
        fontFamily: "'PP Mori', 'PPMori', -apple-system, BlinkMacSystemFont, sans-serif",
    },
    screenSecondaryButton: {
        backgroundColor: "transparent",
        color: "#1a1a2e",
        borderRadius: 30,
        padding: "10px 24px",
        fontSize: 14,
        fontWeight: 500,
        textAlign: "center" as const,
        marginBottom: 8,
        textDecoration: "underline",
    },
    screenFooterText: {
        fontSize: 12,
        color: "#1a1a2e",
        textAlign: "center" as const,
        opacity: 0.8,
    },
    screenTicketBadge: {
        backgroundColor: "#1a1a2e",
        color: "#FFAE00",
        borderRadius: 20,
        padding: "6px 16px",
        fontSize: 12,
        fontWeight: 600,
        marginBottom: 12,
    },
    screenMultiplierBadge: {
        backgroundColor: "#e84c8a",
        color: "#fff",
        borderRadius: 4,
        padding: "4px 12px",
        fontSize: 11,
        fontWeight: 700,
        position: "absolute" as const,
        top: 12,
        right: 12,
    },
    screenWinnerHighlight: {
        backgroundColor: "rgba(255,255,255,0.4)",
        borderRadius: 12,
        padding: "8px 16px",
        marginBottom: 12,
        fontSize: 13,
        color: "#1a1a2e",
    },
    screenBoostBadge: {
        backgroundColor: "#2e7d32",
        color: "#fff",
        borderRadius: 20,
        padding: "6px 16px",
        fontSize: 12,
        fontWeight: 600,
        marginTop: 8,
    },
    // Draw Management Styles
    drawManagementContainer: {
        display: "flex",
        flexDirection: "column" as const,
        gap: 24,
    },
    drawStatusCard: {
        padding: 24,
        backgroundColor: "#fff",
        borderRadius: 12,
        border: "1px solid #e0e0e0",
    },
    drawStatusHeader: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: 16,
    },
    drawStatusBadge: {
        padding: "6px 16px",
        borderRadius: 20,
        fontSize: 13,
        fontWeight: 600,
    },
    drawStatsGrid: {
        display: "grid",
        gridTemplateColumns: "repeat(4, 1fr)",
        gap: 16,
        marginTop: 16,
    },
    drawStatBox: {
        textAlign: "center" as const,
        padding: 16,
        backgroundColor: "#f5f5f5",
        borderRadius: 8,
    },
    drawStatValue: {
        fontSize: 28,
        fontWeight: 700,
        color: "#1a1a2e",
    },
    drawStatLabel: {
        fontSize: 12,
        color: "#666",
        marginTop: 4,
    },
    drawActionButtons: {
        display: "flex",
        gap: 16,
        marginTop: 24,
    },
    preliminaryResultsTable: {
        marginTop: 24,
    },
    tierGroupHeader: {
        backgroundColor: "#f5f5f5",
        padding: "12px 16px",
        fontWeight: 600,
        fontSize: 14,
        borderBottom: "1px solid #e0e0e0",
    },
    warningBanner: {
        display: "flex",
        alignItems: "center",
        gap: 12,
        padding: 16,
        backgroundColor: "#fff3e0",
        borderRadius: 8,
        marginBottom: 16,
        border: "1px solid #ffcc80",
    },
    successBanner: {
        display: "flex",
        alignItems: "center",
        gap: 12,
        padding: 16,
        backgroundColor: "#e8f5e9",
        borderRadius: 8,
        marginBottom: 16,
        border: "1px solid #a5d6a7",
    },
    winnerRow: {
        "&:hover": {
            backgroundColor: "#f5f5f5",
        },
    },
    monthlyWinnerChip: {
        backgroundColor: "#ffebee",
        color: "#c62828",
        padding: "2px 8px",
        borderRadius: 12,
        fontSize: 11,
        marginLeft: 8,
    },
}));

interface PrizeTier {
    id?: number;
    tier_rank: number;
    prize_amount: number;
    winner_count: number;
    min_tickets_for_eligibility: number;
    ticket_weight_multiplier: number;
    display_label: string;
    display_color: string;
    is_top_prize: boolean;
}

interface FeaturedWinner {
    id?: number;
    config_id: number;
    name: string;
    prize_amount: number;
    tier_label?: string;
    display_order: number;
    is_active: boolean;
}

interface PrizeDrawConfigFormValues {
    id?: number;
    name?: string;
    // Mode Toggle
    is_prize_draw_enabled?: boolean;
    disable_after_current_week?: boolean;
    // Budget
    weekly_budget?: number;
    fallback_prize_amount?: number;
    fallback_enabled?: boolean;
    boost_only_after_budget?: boolean;
    // Participation Mode
    participation_mode?: boolean;
    base_prize_per_ticket?: number;
    // Ambassador
    ambassador_threshold?: number;
    ambassador_flat_reward?: number;
    // Boost
    boost_weeks_per_ticket?: number;
    max_boost_weeks?: number;
    boost_haircut_percentage?: number;
    // Multiplier
    current_multiplier?: number;
    multiplier_start_date?: string;
    multiplier_end_date?: string;
    // Schedule
    week_start_day?: number;
    week_start_time?: string;
    draw_time?: string;
    announcement_time?: string;
    // Monthly Restriction
    top_prize_threshold?: number;
    // Status
    is_active?: boolean;
    priority?: number;
    // Campaign Dates
    start_date?: string;
    end_date?: string;
    // UAT/Testing Mode
    is_uat_mode?: boolean;
    draw_interval_hours?: number;
    next_draw_datetime?: string;
    // Screen Config - JSON structure
    screen_config?: {
        no_entry?: {
            header?: string;
            title?: string;
            title2?: string;
            subtitle?: string;
            cta?: string;
            secondary_info?: string;
            footer?: string;
        };
        active_entry?: {
            title?: string;
            title2?: string;
            subtitle?: string;
            winner_highlight?: string;
            cta?: string;
            footer?: string;
        };
        pending_claim?: {
            title?: string;
            title2?: string;
            subtitle?: string;
            cta?: string;
            footer?: string;
        };
        claimed?: {
            title?: string;
            title2?: string;
            subtitle?: string;
            secondary_info?: string;
            boost_badge?: string;
            footer?: string;
        };
        multiplier?: {
            badge_text?: string;
            header?: string;
            title_suffix?: string;
        };
    };
}

interface CampaignListItem {
    id: number;
    name: string;
    is_active: boolean;
    is_prize_draw_enabled: boolean;
}

interface PrizeDrawWeek {
    id: number;
    week_number: number;
    year: number;
    start_date: string;
    end_date: string;
    status: 'upcoming' | 'active' | 'draw_pending' | 'draw_in_review' | 'draw_confirmed' | 'announced' | 'completed' | 'cancelled';
    total_budget: number;
    total_spent: number;
    total_entries: number;
    total_participants: number;
    multiplier: number;
    config_id: number;
}

interface DrawParticipant {
    userId: number;
    userName: string;
    userEmail: string;
    tickets: number;
    effectiveTickets: number;
    hasWonTopPrizeThisMonth: boolean;
}

interface PreliminaryResult {
    userId: number;
    userName: string;
    userEmail: string;
    tickets: number;
    effectiveTickets: number;
    prizeAmount: number;
    tierRank?: number;
    tierLabel?: string;
    boostWeeks: number;
    hasWonThisMonth?: boolean;
    isEligibleForTier?: boolean;
    claimStatus?: string;
    basePrize?: number; // Original calculated prize (for participation mode)
    rank?: number; // Position by ticket count (for participation mode)
}

interface DrawSummary {
    totalParticipants: number;
    totalSpend: number;
    budgetRemaining: number;
    byTier: Array<{
        tierRank: number;
        tierLabel: string;
        prizeAmount: number;
        winners: number;
        totalSpend: number;
    }>;
}

interface DrawWarning {
    type: 'monthly_winner' | 'low_tickets' | 'budget_exceeded';
    userId?: number;
    message: string;
}

const renderInput = ({
    meta: { touched, error } = { touched: false, error: undefined },
    input: { ...inputProps },
    label,
    ...props
}: any) => (
    <div>
        {label && <Typography variant="caption" style={{ color: '#666', marginBottom: 4, display: 'block' }}>{label}</Typography>}
        <TextField
            {...props}
            {...inputProps}
            error={!!(touched && error)}
            helperText={touched && error}
            fullWidth
            variant="outlined"
            size="small"
        />
    </div>
);

const renderNumberInput = ({
    meta: { touched, error } = { touched: false, error: undefined },
    input: { ...inputProps },
    label,
    ...props
}: any) => (
    <div>
        {label && <Typography variant="caption" style={{ color: '#666', marginBottom: 4, display: 'block' }}>{label}</Typography>}
        <TextField
            {...props}
            {...inputProps}
            error={!!(touched && error)}
            helperText={touched && error}
            fullWidth
            variant="outlined"
            size="small"
            type="number"
        />
    </div>
);

const renderCurrencyInput = ({
    meta: { touched, error } = { touched: false, error: undefined },
    input: { ...inputProps },
    label,
    ...props
}: any) => (
    <div>
        {label && <Typography variant="caption" style={{ color: '#666', marginBottom: 4, display: 'block' }}>{label}</Typography>}
        <TextField
            {...props}
            {...inputProps}
            error={!!(touched && error)}
            helperText={touched && error}
            fullWidth
            variant="outlined"
            size="small"
            type="number"
            InputProps={{
                startAdornment: <InputAdornment position="start">£</InputAdornment>,
            }}
        />
    </div>
);

const renderTimeInput = ({
    meta: { touched, error } = { touched: false, error: undefined },
    input: { ...inputProps },
    label,
    ...props
}: any) => (
    <div>
        {label && <Typography variant="caption" style={{ color: '#666', marginBottom: 4, display: 'block' }}>{label}</Typography>}
        <TextField
            {...props}
            {...inputProps}
            error={!!(touched && error)}
            helperText={touched && error}
            fullWidth
            variant="outlined"
            size="small"
            type="time"
        />
    </div>
);

const renderDateInput = ({
    meta: { touched, error } = { touched: false, error: undefined },
    input: { ...inputProps },
    label,
    ...props
}: any) => (
    <div>
        {label && <Typography variant="caption" style={{ color: '#666', marginBottom: 4, display: 'block' }}>{label}</Typography>}
        <TextField
            {...props}
            {...inputProps}
            error={!!(touched && error)}
            helperText={touched && error}
            fullWidth
            variant="outlined"
            size="small"
            type="date"
            InputLabelProps={{ shrink: true }}
        />
    </div>
);

const renderSwitch = ({ input, label }: any) => {
    const isChecked = input.checked !== undefined ? input.checked : !!input.value;
    return (
        <FormControlLabel
            control={
                <Switch
                    checked={isChecked}
                    onChange={(event) => {
                        input.onChange(event.target.checked);
                    }}
                    color="primary"
                />
            }
            label={label}
        />
    );
};

const { Form } = withTypes<PrizeDrawConfigFormValues>();

const PRIZE_DRAW_CONFIG_ENDPOINT = API + "/prize-draw-config";
const PRIZE_DRAW_TIER_ENDPOINT = API + "/prize-draw-tier";
const PRIZE_DRAW_WEEK_ENDPOINT = API + "/prize-draw-week";
const PRIZE_DRAW_MANAGEMENT_ENDPOINT = API + "/prize-draw-management";
const PRIZE_DRAW_FEATURED_WINNER_ENDPOINT = API + "/prize-draw-featured-winner";

const PrizeDrawConfig = () => {
    const [loading, setLoading] = useState(false);
    const [initialLoading, setInitialLoading] = useState(true);
    const [configId, setConfigId] = useState<number | null>(null);
    const [initialValues, setInitialValues] = useState<PrizeDrawConfigFormValues>({});
    const [expandedSections, setExpandedSections] = useState<string[]>(["mode", "budget"]);
    const [campaigns, setCampaigns] = useState<CampaignListItem[]>([]);
    const [selectedCampaignId, setSelectedCampaignId] = useState<number | null>(null);
    const [isCreatingNew, setIsCreatingNew] = useState(false);
    const [prizeTiers, setPrizeTiers] = useState<PrizeTier[]>([]);
    const [tierDialogOpen, setTierDialogOpen] = useState(false);
    const [editingTier, setEditingTier] = useState<PrizeTier | null>(null);
    const [selectedScreenVariation, setSelectedScreenVariation] = useState<string>('no_entry');
    // Draw Management State
    const [currentWeek, setCurrentWeek] = useState<PrizeDrawWeek | null>(null);
    const [recentlyCompletedWeek, setRecentlyCompletedWeek] = useState<PrizeDrawWeek | null>(null);
    const [recentlyCompletedResults, setRecentlyCompletedResults] = useState<PreliminaryResult[]>([]);
    // drawParticipants state reserved for future use
    const [preliminaryResults, setPreliminaryResults] = useState<PreliminaryResult[]>([]);
    const [drawSummary, setDrawSummary] = useState<DrawSummary | null>(null);
    const [drawWarnings, setDrawWarnings] = useState<DrawWarning[]>([]);
    const [isRunningDraw, setIsRunningDraw] = useState(false);
    const [isConfirmingDraw, setIsConfirmingDraw] = useState(false);
    const [drawCompleted, setDrawCompleted] = useState(false);
    // Archive State
    const [archiveModalOpen, setArchiveModalOpen] = useState(false);
    const [archivedWeeks, setArchivedWeeks] = useState<PrizeDrawWeek[]>([]);
    const [selectedArchiveWeek, setSelectedArchiveWeek] = useState<PrizeDrawWeek | null>(null);
    const [archiveResults, setArchiveResults] = useState<PreliminaryResult[]>([]);
    const [processingStatus, setProcessingStatus] = useState<{
        status: string;
        progress?: { processed?: number; total?: number; successCount?: number; failCount?: number };
    } | null>(null);
    const [, setIsPollingStatus] = useState(false);
    // Adjust Winner State
    const [adjustDialogOpen, setAdjustDialogOpen] = useState(false);
    const [adjustingResult, setAdjustingResult] = useState<PreliminaryResult | null>(null);
    const [adjustNewTier, setAdjustNewTier] = useState<number>(0);
    const [adjustNewUserId, setAdjustNewUserId] = useState<number | null>(null);
    const [adjustNewPrize, setAdjustNewPrize] = useState<string>('');  // Custom prize amount override
    const [adjustReason, setAdjustReason] = useState('');
    // All participants for user selection dropdown
    const [allParticipants, setAllParticipants] = useState<Array<{userId: number; userName: string; userEmail: string; totalTickets: number; basePrize?: number}>>([]);
    // Participation Mode State (from run-draw response)
    const [isParticipationMode, setIsParticipationMode] = useState(false);
    const [participationTopPrizes, setParticipationTopPrizes] = useState<number[]>([1000, 500, 250, 100]);
    // UAT Test Data State
    const [isCreatingTestData, setIsCreatingTestData] = useState(false);
    // Featured Winners State
    const [featuredWinners, setFeaturedWinners] = useState<FeaturedWinner[]>([]);
    const [newFeaturedName, setNewFeaturedName] = useState('');
    const [newFeaturedAmount, setNewFeaturedAmount] = useState('');
    const [isSavingFeatured, setIsSavingFeatured] = useState(false);
    const notify = useNotify();
    const classes = useStyles();

    useEffect(() => {
        fetchConfig();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const fetchConfig = async () => {
        try {
            setInitialLoading(true);
            const config = getConfigGet({});
            const response: any = await axios.get(PRIZE_DRAW_CONFIG_ENDPOINT, config);

            if (response.data?.data?.length > 0) {
                const allCampaigns = response.data.data;
                const campaignList: CampaignListItem[] = allCampaigns.map((c: any) => ({
                    id: c.id,
                    name: c.name || 'Default',
                    is_active: c.is_active,
                    is_prize_draw_enabled: c.is_prize_draw_enabled
                }));
                setCampaigns(campaignList);

                const defaultCampaign = allCampaigns.find((c: any) => c.name === 'Default Prize Draw Campaign' || c.is_active) || allCampaigns[0];
                loadCampaignData(defaultCampaign);
                setSelectedCampaignId(defaultCampaign.id);
            }
        } catch (error) {
            console.error("Failed to fetch config:", error);
            notify("Failed to load prize draw configuration", "warning");
        } finally {
            setInitialLoading(false);
        }
    };

    const loadCampaignData = async (configData: any) => {
        setConfigId(configData.id);
        setInitialValues({
            ...configData,
            start_date: configData.start_date ? configData.start_date.split('T')[0] : '',
            end_date: configData.end_date ? configData.end_date.split('T')[0] : '',
            multiplier_start_date: configData.multiplier_start_date ? configData.multiplier_start_date.split('T')[0] : '',
            multiplier_end_date: configData.multiplier_end_date ? configData.multiplier_end_date.split('T')[0] : '',
            is_prize_draw_enabled: configData.is_prize_draw_enabled === true || configData.is_prize_draw_enabled === 1,
            disable_after_current_week: configData.disable_after_current_week === true || configData.disable_after_current_week === 1,
            fallback_enabled: configData.fallback_enabled === true || configData.fallback_enabled === 1,
            boost_only_after_budget: configData.boost_only_after_budget === true || configData.boost_only_after_budget === 1,
            is_active: configData.is_active === true || configData.is_active === 1,
            // UAT Mode
            is_uat_mode: configData.is_uat_mode === true || configData.is_uat_mode === 1,
            next_draw_datetime: configData.next_draw_datetime ? configData.next_draw_datetime.slice(0, 16) : '',
        });

        // Fetch prize tiers for this config
        try {
            const tierConfig = getConfigGet({ config_id: configData.id });
            const tierResponse: any = await axios.get(PRIZE_DRAW_TIER_ENDPOINT, tierConfig);
            if (tierResponse.data?.data) {
                setPrizeTiers(tierResponse.data.data.sort((a: PrizeTier, b: PrizeTier) => a.tier_rank - b.tier_rank));
            }
        } catch (error) {
            console.error("Failed to fetch prize tiers:", error);
        }

        // Fetch featured winners for this config
        try {
            const featuredConfig = getConfigGet({ config_id: configData.id });
            const featuredResponse: any = await axios.get(PRIZE_DRAW_FEATURED_WINNER_ENDPOINT, featuredConfig);
            if (featuredResponse.data?.data) {
                setFeaturedWinners(featuredResponse.data.data.sort((a: FeaturedWinner, b: FeaturedWinner) => a.display_order - b.display_order));
            } else {
                setFeaturedWinners([]);
            }
        } catch (error) {
            console.error("Failed to fetch featured winners:", error);
            setFeaturedWinners([]);
        }
    };

    const handleCampaignChange = async (event: React.ChangeEvent<{ value: unknown }>) => {
        const value = event.target.value;
        if (value === 'new') {
            setIsCreatingNew(true);
            setSelectedCampaignId(null);
            setConfigId(null);
            setInitialValues({
                name: '',
                is_prize_draw_enabled: true,
                weekly_budget: 2500,
                fallback_prize_amount: 5,
                fallback_enabled: true,
                participation_mode: false,
                base_prize_per_ticket: 5,
                ambassador_threshold: 10,
                ambassador_flat_reward: 10,
                boost_weeks_per_ticket: 1,
                max_boost_weeks: 10,
                current_multiplier: 1,
                week_start_day: 1,
                week_start_time: '07:00',
                draw_time: '00:00',
                announcement_time: '06:00',
                top_prize_threshold: 10,
                is_active: false,
                priority: 100,
                // UAT Testing Mode
                is_uat_mode: false,
                draw_interval_hours: 24,
                next_draw_datetime: '',
                // Screen Config - JSON structure
                screen_config: {
                    no_entry: {
                        header: 'Exclusive to Sprive Plus',
                        title: 'Earn boosts AND £5 to £1,000',
                        title2: 'Every referral = 1 ticket',
                        subtitle: 'Your odds are better than you think...',
                        cta: 'Refer a friend',
                        secondary_info: 'Anyone with 10+ referrals switches to our Sprive Ambassador program instead.',
                        footer: 'All prizes overpay your mortgage. Read terms.'
                    },
                    active_entry: {
                        title: "You're in! Draw in:",
                        title2: 'You have {tickets} ticket(s)',
                        subtitle: 'Last week {count} winners won {amount}',
                        winner_highlight: "Last week's £1k winner did {count} referrals",
                        cta: 'Double your chances',
                        footer: 'Next draw: Monday 7am'
                    },
                    pending_claim: {
                        title: 'The results are in!',
                        title2: 'Tap to reveal your prize',
                        subtitle: 'You had {tickets} ticket(s) this week',
                        cta: 'Claim now',
                        footer: 'Your result is waiting'
                    },
                    claimed: {
                        title: 'You won {amount}!',
                        title2: 'Added to your Sprive wallet',
                        subtitle: 'Congrats! Keep referring to win more.',
                        secondary_info: 'Better luck next time!',
                        boost_badge: '+{weeks} weeks boost earned',
                        footer: 'Next draw starts Monday'
                    },
                    multiplier: {
                        badge_text: '{multiplier}X TICKETS',
                        header: 'DOUBLE TICKETS EVENT',
                        title_suffix: '({multiplier}X this week!)'
                    }
                }
            });
            setPrizeTiers([]);
        } else {
            setIsCreatingNew(false);
            const campaignId = value as number;
            setSelectedCampaignId(campaignId);
            try {
                const config = getConfigGet({});
                const response: any = await axios.get(`${PRIZE_DRAW_CONFIG_ENDPOINT}/${campaignId}`, config);
                if (response.data) {
                    loadCampaignData(response.data);
                }
            } catch (error) {
                console.error("Failed to load campaign:", error);
                notify("Failed to load campaign", "warning");
            }
        }
    };

    // Fetch current week data for draw management
    // Priority: draw_in_review > processing_queued > processing > active
    const fetchCurrentWeek = async () => {
        if (!configId) return;
        try {
            const config = getConfigGet({});

            // First, check for weeks needing attention (in review or processing)
            const reviewResponse: any = await axios.get(
                `${PRIZE_DRAW_WEEK_ENDPOINT}?config_id=${configId}&status[$in][]=draw_in_review&status[$in][]=processing_queued&status[$in][]=processing&$sort[id]=-1&$limit=1`,
                config
            );

            if (reviewResponse.data?.data?.length > 0) {
                const weekInReview = reviewResponse.data.data[0];
                setCurrentWeek(weekInReview);

                // If week is in review, fetch the existing editable results
                if (weekInReview.status === 'draw_in_review') {
                    fetchEditableResults(weekInReview.id);
                }

                // Also fetch recently completed week
                fetchRecentlyCompletedWeek();
                return;
            }

            // If no weeks in review, get the latest active week
            const response: any = await axios.get(
                `${PRIZE_DRAW_WEEK_ENDPOINT}?config_id=${configId}&status=active&$sort[id]=-1&$limit=1`,
                config
            );
            if (response.data?.data?.length > 0) {
                setCurrentWeek(response.data.data[0]);
            }

            // Also fetch recently completed week
            fetchRecentlyCompletedWeek();
        } catch (error) {
            console.error("Failed to fetch current week:", error);
        }
    };

    // Fetch recently completed week (draw_confirmed or completed)
    const fetchRecentlyCompletedWeek = async () => {
        if (!configId) return;
        try {
            const config = getConfigGet({});
            const response: any = await axios.get(
                `${PRIZE_DRAW_WEEK_ENDPOINT}?config_id=${configId}&status[$in][]=draw_confirmed&status[$in][]=completed&$sort[id]=-1&$limit=1`,
                config
            );

            if (response.data?.data?.length > 0) {
                const completedWeek = response.data.data[0];
                setRecentlyCompletedWeek(completedWeek);

                // Fetch results for this completed week
                const headers = getConfigPost();
                const resultsResponse: any = await axios.post(PRIZE_DRAW_MANAGEMENT_ENDPOINT, {
                    action: "get-editable-results",
                    weekId: completedWeek.id
                }, { headers });

                if (resultsResponse.data?.editableResults) {
                    setRecentlyCompletedResults(resultsResponse.data.editableResults);
                }
            }
        } catch (error) {
            console.error("Failed to fetch recently completed week:", error);
        }
    };

    // Fetch existing editable results for a week in review
    const fetchEditableResults = async (weekId: number) => {
        try {
            const headers = getConfigPost();
            const response: any = await axios.post(PRIZE_DRAW_MANAGEMENT_ENDPOINT, {
                action: "get-editable-results",
                weekId
            }, { headers });

            if (response.data?.success && response.data?.editableResults) {
                setPreliminaryResults(response.data.editableResults);
            }
            if (response.data?.allParticipants) {
                setAllParticipants(response.data.allParticipants);
            }
        } catch (error) {
            console.error("Failed to fetch editable results:", error);
        }
    };

    // Fetch all archived weeks for archive modal
    const fetchArchivedWeeks = async () => {
        if (!configId) return;
        try {
            const config = getConfigGet({});
            const response: any = await axios.get(
                `${PRIZE_DRAW_WEEK_ENDPOINT}?config_id=${configId}&$sort[id]=-1&$limit=50`,
                config
            );

            if (response.data?.data) {
                setArchivedWeeks(response.data.data);
            }
        } catch (error) {
            console.error("Failed to fetch archived weeks:", error);
        }
    };

    // Fetch results for a specific archive week
    const fetchArchiveWeekResults = async (weekId: number) => {
        try {
            const headers = getConfigPost();
            const response: any = await axios.post(PRIZE_DRAW_MANAGEMENT_ENDPOINT, {
                action: "get-editable-results",
                weekId
            }, { headers });

            if (response.data?.editableResults) {
                setArchiveResults(response.data.editableResults);
            }
        } catch (error) {
            console.error("Failed to fetch archive results:", error);
        }
    };

    // Open archive modal
    const handleOpenArchive = () => {
        fetchArchivedWeeks();
        setArchiveModalOpen(true);
    };

    // Select a week from archive
    const handleSelectArchiveWeek = (week: PrizeDrawWeek) => {
        setSelectedArchiveWeek(week);
        fetchArchiveWeekResults(week.id);
    };

    // Run the draw (generates preliminary results)
    const handleRunDraw = async () => {
        if (!currentWeek) {
            notify("No active week found", "warning");
            return;
        }
        setIsRunningDraw(true);
        try {
            const headers = getConfigPost();
            const response: any = await axios.post(PRIZE_DRAW_MANAGEMENT_ENDPOINT, {
                action: "run-draw",
                weekId: currentWeek.id,
                configId: configId
            }, { headers });

            if (response.data?.success) {
                // Backend returns all results + all participants for editing
                setPreliminaryResults(response.data.editableResults || response.data.preliminaryResults || []);
                if (response.data.allParticipants) {
                    setAllParticipants(response.data.allParticipants);
                }
                // Set participation mode from response
                if (response.data.participationMode) {
                    setIsParticipationMode(true);
                    setParticipationTopPrizes(response.data.topPrizes || [1000, 500, 250, 100]);
                } else {
                    setIsParticipationMode(false);
                }
                // Calculate totalSpend from byTier if not provided
                const summary = response.data.summary || {};
                const byTierTotal = (summary.byTier || []).reduce((sum: number, t: any) => sum + (t.totalSpend || 0), 0);
                const calculatedTotalSpend = summary.totalSpend || byTierTotal;
                const calculatedBudgetRemaining = summary.budgetRemaining || ((currentWeek?.total_budget || 2500) - calculatedTotalSpend);
                setDrawSummary({
                    ...summary,
                    totalSpend: calculatedTotalSpend,
                    budgetRemaining: calculatedBudgetRemaining
                });
                setDrawWarnings(response.data.warnings || []);
                setDrawCompleted(false);
                notify("Draw executed! Review the results below.", "info");
                // Refresh current week status
                fetchCurrentWeek();
            } else {
                notify(response.data?.error || "Failed to run draw", "warning");
            }
        } catch (error: any) {
            console.error("Failed to run draw:", error);
            notify(error.response?.data?.message || "Failed to run draw", "warning");
        } finally {
            setIsRunningDraw(false);
        }
    };

    // Poll for draw processing status
    const pollDrawStatus = async (weekId: number) => {
        setIsPollingStatus(true);
        const headers = getConfigPost();

        const poll = async () => {
            try {
                const response: any = await axios.post(PRIZE_DRAW_MANAGEMENT_ENDPOINT, {
                    action: "get-draw-status",
                    weekId
                }, { headers });

                if (response.data?.success) {
                    setProcessingStatus({
                        status: response.data.status,
                        progress: response.data.progress
                    });

                    // Check if processing is complete
                    if (['draw_confirmed', 'draw_failed'].includes(response.data.status)) {
                        setIsPollingStatus(false);
                        setIsConfirmingDraw(false);
                        if (response.data.status === 'draw_confirmed') {
                            setDrawCompleted(true);
                            const progress = response.data.progress || {};
                            notify(`Draw confirmed! ${progress.successCount || 0} winners processed successfully.`, "info");
                        } else {
                            notify(`Draw processing failed: ${response.data.progress?.error || 'Unknown error'}`, "warning");
                        }
                        fetchCurrentWeek();
                        return; // Stop polling
                    }

                    // Continue polling every 2 seconds
                    setTimeout(poll, 2000);
                } else {
                    // Error response but not a failure - keep polling
                    setTimeout(poll, 2000);
                }
            } catch (error: any) {
                console.error("Failed to poll status:", error);
                // On error, stop polling after a few attempts
                setTimeout(poll, 3000);
            }
        };

        poll();
    };

    // Confirm the draw (queues for async processing via SQS)
    // Note: Results are already saved to DB by runDraw, so we just send weekId
    const handleConfirmDraw = async () => {
        if (!currentWeek) {
            notify("No week selected", "warning");
            return;
        }
        if (currentWeek.status !== 'draw_in_review') {
            notify(`Cannot confirm - week status is ${currentWeek.status}`, "warning");
            return;
        }
        if (!window.confirm("Are you sure you want to confirm this draw? This will finalize the results and notify winners.")) {
            return;
        }
        setIsConfirmingDraw(true);
        setProcessingStatus(null);
        try {
            const headers = getConfigPost();

            // Build topTierEdits based on mode
            let topTierEdits: any[];

            if (isParticipationMode) {
                // PARTICIPATION MODE: Only send edits where prize was changed from base
                topTierEdits = preliminaryResults
                    .filter(r => r.prizeAmount !== r.basePrize) // Only send if prize was changed
                    .map(r => ({
                        userId: r.userId,
                        prizeAmount: r.prizeAmount
                    }));
            } else {
                // LOTTERY MODE: Send top tier edits
                topTierEdits = preliminaryResults
                    .filter(r => (r.tierRank || 0) <= 3)
                    .map(r => ({
                        tierRank: r.tierRank || 0,
                        userId: r.userId,
                        prizeAmount: r.prizeAmount,
                        boostWeeks: r.boostWeeks
                    }));
            }

            console.log('[DEBUG] confirm-draw payload:', {
                weekId: currentWeek.id,
                isParticipationMode,
                topTierEdits
            });

            const response: any = await axios.post(PRIZE_DRAW_MANAGEMENT_ENDPOINT, {
                action: "confirm-draw",
                weekId: currentWeek.id,
                topTierEdits
            }, { headers });

            if (response.data?.success) {
                const totalWinners = response.data.totalWinners || 0;
                // Check if processing is queued (async) or immediate (sync)
                if (response.data.status === 'processing_queued') {
                    notify(`Draw queued for processing. ${totalWinners} winners will receive prizes shortly.`, "info");
                    setProcessingStatus({ status: 'processing_queued', progress: { total: totalWinners, processed: 0 } });
                    // Start polling for status
                    pollDrawStatus(currentWeek.id);
                } else {
                    // Immediate completion (sync mode)
                    setDrawCompleted(true);
                    setIsConfirmingDraw(false);
                    notify(`Draw confirmed! ${totalWinners} winners. Notifications scheduled.`, "info");
                    fetchCurrentWeek();
                }
            } else {
                setIsConfirmingDraw(false);
                notify(response.data?.error || "Failed to confirm draw", "warning");
            }
        } catch (error: any) {
            console.error("Failed to confirm draw:", error);
            setIsConfirmingDraw(false);
            notify(error.response?.data?.message || "Failed to confirm draw", "warning");
        }
    };

    // Format status badge color
    const getStatusColor = (status: string) => {
        switch (status) {
            case 'active': return { bg: '#e8f5e9', color: '#2e7d32' };
            case 'grace_period': return { bg: '#fff3e0', color: '#e65100' };
            case 'draw_pending': return { bg: '#e3f2fd', color: '#1565c0' };
            case 'draw_in_review': return { bg: '#fce4ec', color: '#c2185b' };
            case 'processing_queued': return { bg: '#fff8e1', color: '#ff8f00' };
            case 'processing': return { bg: '#fff3e0', color: '#e65100' };
            case 'draw_confirmed': return { bg: '#f3e5f5', color: '#7b1fa2' };
            case 'draw_failed': return { bg: '#ffebee', color: '#c62828' };
            case 'announced': return { bg: '#e8f5e9', color: '#2e7d32' };
            case 'completed': return { bg: '#eceff1', color: '#546e7a' };
            default: return { bg: '#f5f5f5', color: '#666' };
        }
    };

    // Create/refresh week for UAT
    const handleCreateTestWeek = async () => {
        if (!configId) {
            notify('Please save a campaign configuration first', 'warning');
            return;
        }
        setIsCreatingTestData(true);
        try {
            const headers = getConfigPost();
            const response: any = await axios.post(PRIZE_DRAW_MANAGEMENT_ENDPOINT, {
                action: 'create-test-week',
                configId: configId
            }, { headers });

            if (response.data?.success) {
                const msg = response.data.message || `Week ${response.data.week.week_number}/${response.data.week.year} ready`;
                notify(msg, 'info');
                setCurrentWeek(response.data.week);
            } else {
                notify(response.data?.error || 'Failed to create week', 'warning');
            }
        } catch (error: any) {
            console.error('Failed to create week:', error);
            notify(error.response?.data?.message || 'Failed to create week', 'warning');
        } finally {
            setIsCreatingTestData(false);
        }
    };

    // Clear test data / reset week
    const handleClearTestData = async () => {
        if (!window.confirm('Are you sure you want to reset? This will delete the current week, all entries, and results.')) {
            return;
        }
        setIsCreatingTestData(true);
        try {
            const headers = getConfigPost();
            const response: any = await axios.post(PRIZE_DRAW_MANAGEMENT_ENDPOINT, {
                action: 'clear-test-data',
                configId: configId
            }, { headers });

            if (response.data?.success) {
                notify('Week reset. You can create a new week now.', 'info');
                setCurrentWeek(null);
                setPreliminaryResults([]);
                setDrawSummary(null);
                setDrawWarnings([]);
            } else {
                notify(response.data?.error || 'Failed to reset', 'warning');
            }
        } catch (error: any) {
            console.error('Failed to reset:', error);
            notify(error.response?.data?.message || 'Failed to reset', 'warning');
        } finally {
            setIsCreatingTestData(false);
        }
    };

    // Start new week (for UAT - keeps old week as completed, creates new one)
    const handleStartNewWeek = async () => {
        if (!window.confirm('Start a new draw week? The current week will be marked as completed and a new week will be created.')) {
            return;
        }
        setIsCreatingTestData(true);
        try {
            const headers = getConfigPost();
            const response: any = await axios.post(PRIZE_DRAW_MANAGEMENT_ENDPOINT, {
                action: 'start-new-week',
                configId: configId
            }, { headers });

            if (response.data?.success) {
                notify(`New week ${response.data.week?.weekNumber} created!`, 'info');
                // Refresh the week data
                await fetchCurrentWeek();
                setPreliminaryResults([]);
                setDrawSummary(null);
                setDrawWarnings([]);
            } else {
                notify(response.data?.error || 'Failed to start new week', 'warning');
            }
        } catch (error: any) {
            console.error('Failed to start new week:', error);
            notify(error.response?.data?.message || 'Failed to start new week', 'warning');
        } finally {
            setIsCreatingTestData(false);
        }
    };

    // Open adjust winner dialog
    const handleOpenAdjustDialog = (result: PreliminaryResult) => {
        setAdjustingResult(result);
        setAdjustNewTier(0);  // 0 = keep current tier
        setAdjustNewUserId(null);  // null = keep current user
        setAdjustNewPrize('');  // Clear custom prize
        setAdjustReason('');
        setAdjustDialogOpen(true);
    };

    // Apply adjustment to preliminary results (local state update before confirm)
    const handleApplyAdjustment = () => {
        if (!adjustingResult || !adjustReason.trim()) {
            notify('Please provide a reason for the adjustment', 'warning');
            return;
        }

        // Determine effective tier (0 = keep current)
        const effectiveTier = adjustNewTier === 0 ? adjustingResult.tierRank : adjustNewTier;

        // Find the tier info for the new tier (use == to handle string/number type mismatch from API)
        const newTier = prizeTiers.find(t => Number(t.tier_rank) === Number(effectiveTier));

        // DEBUG: Log tier lookup with type info
        console.log('[DEBUG] handleApplyAdjustment:', {
            adjustNewTier,
            adjustNewTierType: typeof adjustNewTier,
            effectiveTier,
            effectiveTierType: typeof effectiveTier,
            prizeTiers: prizeTiers.map(t => ({
                tier_rank: t.tier_rank,
                tier_rank_type: typeof t.tier_rank,
                prize_amount: t.prize_amount,
                prize_amount_type: typeof t.prize_amount,
                label: t.display_label
            })),
            newTier: newTier ? { tier_rank: newTier.tier_rank, prize_amount: newTier.prize_amount } : 'NOT FOUND - TYPE MISMATCH?',
            adjustNewPrize,
            currentPrize: adjustingResult.prizeAmount
        });

        // Get new user info if swapping
        const newUser = adjustNewUserId ? allParticipants.find(p => p.userId === adjustNewUserId) : null;

        // Determine prize amount: custom prize takes priority, then tier default, then keep current
        // Note: tier.prize_amount comes as string from API, need to parse
        const customPrize = adjustNewPrize ? parseFloat(adjustNewPrize) : null;
        const tierPrize = newTier?.prize_amount ? parseFloat(String(newTier.prize_amount)) : null;
        const effectivePrize = customPrize !== null ? customPrize : (tierPrize || adjustingResult.prizeAmount);

        console.log('[DEBUG] Prize calculation:', { customPrize, tierPrize, effectivePrize });

        // Update the preliminary results
        setPreliminaryResults(prev => prev.map(r => {
            if (r.userId === adjustingResult.userId) {
                if (newUser) {
                    // Swap to new user
                    return {
                        ...r,
                        userId: newUser.userId,
                        userName: newUser.userName,
                        userEmail: newUser.userEmail,
                        effectiveTickets: newUser.totalTickets,
                        tierRank: effectiveTier,
                        tierLabel: newTier?.display_label || `Tier ${effectiveTier}`,
                        prizeAmount: effectivePrize
                    };
                } else if (adjustNewTier !== 0 || customPrize !== null) {
                    // Change tier or prize amount
                    return {
                        ...r,
                        tierRank: effectiveTier,
                        tierLabel: newTier?.display_label || `Tier ${effectiveTier}`,
                        prizeAmount: effectivePrize
                    };
                }
            }
            return r;
        }));

        // Add warning about the adjustment
        const changeDesc: string[] = [];
        if (newUser) changeDesc.push(`User: ${adjustingResult.userName} → ${newUser.userName}`);
        if (adjustNewTier !== 0) changeDesc.push(`Tier: ${adjustingResult.tierLabel} → ${newTier?.display_label}`);
        if (customPrize !== null) changeDesc.push(`Prize: £${adjustingResult.prizeAmount} → £${customPrize}`);

        setDrawWarnings(prev => [
            ...prev,
            {
                type: 'monthly_winner' as const,
                userId: adjustingResult.userId,
                message: `Admin adjustment: ${changeDesc.join(', ')}. Reason: ${adjustReason}`
            }
        ]);

        notify(`Adjustment applied`, 'info');
        setAdjustDialogOpen(false);
        setAdjustingResult(null);
        setAdjustNewUserId(null);
        setAdjustNewPrize('');
    };

    const handleAccordionChange = (section: string) => (event: React.ChangeEvent<{}>, isExpanded: boolean) => {
        setExpandedSections(prev =>
            isExpanded ? [...prev, section] : prev.filter(s => s !== section)
        );
    };

    const handleSubmit = async (values: PrizeDrawConfigFormValues) => {
        setLoading(true);
        try {
            const payload = {
                ...values,
                weekly_budget: parseFloat(String(values.weekly_budget || 0)),
                fallback_prize_amount: parseFloat(String(values.fallback_prize_amount || 0)),
                ambassador_threshold: parseInt(String(values.ambassador_threshold || 0)),
                ambassador_flat_reward: parseFloat(String(values.ambassador_flat_reward || 0)),
                boost_weeks_per_ticket: parseInt(String(values.boost_weeks_per_ticket || 0)),
                max_boost_weeks: parseInt(String(values.max_boost_weeks || 0)),
                boost_haircut_percentage: parseFloat(String(values.boost_haircut_percentage || 0)),
                current_multiplier: parseInt(String(values.current_multiplier || 1)),
                week_start_day: parseInt(String(values.week_start_day || 1)),
                top_prize_threshold: parseFloat(String(values.top_prize_threshold || 0)),
                priority: parseInt(String(values.priority || 100)),
                // UAT Testing Mode
                is_uat_mode: values.is_uat_mode || false,
                draw_interval_hours: values.draw_interval_hours ? parseInt(String(values.draw_interval_hours)) : null,
                next_draw_datetime: values.next_draw_datetime || null,
                // Screen config as JSON
                screen_config: values.screen_config || null,
                // Participation Mode
                participation_mode: values.participation_mode || false,
                base_prize_per_ticket: parseFloat(String(values.base_prize_per_ticket || 5)),
            };

            if (isCreatingNew) {
                const headers = getConfigPost();
                const response: any = await axios.post(PRIZE_DRAW_CONFIG_ENDPOINT, payload, { headers });
                if (response.data?.id) {
                    setConfigId(response.data.id);
                    setIsCreatingNew(false);
                    notify("Prize draw configuration created successfully", "info");
                    fetchConfig();
                }
            } else if (configId) {
                const headers = getConfigPatch();
                await axios.patch(`${PRIZE_DRAW_CONFIG_ENDPOINT}/${configId}`, payload, { headers });
                notify("Prize draw configuration updated successfully", "info");
            }
        } catch (error: any) {
            console.error("Failed to save config:", error);
            notify(error.response?.data?.message || "Failed to save configuration", "warning");
        } finally {
            setLoading(false);
        }
    };

    const handleTierSave = async (tier: PrizeTier) => {
        try {
            const headers = getConfigPost();
            const payload = {
                ...tier,
                config_id: configId,
                tier_rank: parseInt(String(tier.tier_rank)) || 1,
                prize_amount: parseFloat(String(tier.prize_amount)) || 0,
                winner_count: parseInt(String(tier.winner_count)) || 1,
                min_tickets_for_eligibility: parseInt(String(tier.min_tickets_for_eligibility)) || 1,
                ticket_weight_multiplier: parseFloat(String(tier.ticket_weight_multiplier)) || 1,
            };

            if (tier.id) {
                const patchHeaders = getConfigPatch();
                await axios.patch(`${PRIZE_DRAW_TIER_ENDPOINT}/${tier.id}`, payload, { headers: patchHeaders });
                notify("Prize tier updated", "info");
            } else {
                await axios.post(PRIZE_DRAW_TIER_ENDPOINT, payload, { headers });
                notify("Prize tier created", "info");
            }

            // Refresh tiers
            const tierConfig = getConfigGet({ config_id: configId });
            const tierResponse: any = await axios.get(PRIZE_DRAW_TIER_ENDPOINT, tierConfig);
            if (tierResponse.data?.data) {
                setPrizeTiers(tierResponse.data.data.sort((a: PrizeTier, b: PrizeTier) => a.tier_rank - b.tier_rank));
            }
            setTierDialogOpen(false);
            setEditingTier(null);
        } catch (error: any) {
            console.error("Failed to save tier:", error);
            notify(error.response?.data?.message || "Failed to save tier", "warning");
        }
    };

    const handleTierDelete = async (tierId: number) => {
        if (!window.confirm("Are you sure you want to delete this prize tier?")) return;
        try {
            const headers = getConfigPatch();
            await axios.delete(`${PRIZE_DRAW_TIER_ENDPOINT}/${tierId}`, { headers });
            setPrizeTiers(prev => prev.filter(t => t.id !== tierId));
            notify("Prize tier deleted", "info");
        } catch (error) {
            console.error("Failed to delete tier:", error);
            notify("Failed to delete tier", "warning");
        }
    };

    // Featured Winners Functions
    const handleAddFeaturedWinner = async () => {
        if (!newFeaturedName.trim() || !newFeaturedAmount.trim() || !configId) {
            notify("Please enter both name and amount", "warning");
            return;
        }

        const amount = parseFloat(newFeaturedAmount);
        if (isNaN(amount) || amount <= 0) {
            notify("Please enter a valid amount", "warning");
            return;
        }

        setIsSavingFeatured(true);
        try {
            const headers = getConfigPost();
            const payload = {
                config_id: configId,
                name: newFeaturedName.trim(),
                prize_amount: amount,
                tier_label: 'Winner',
                display_order: featuredWinners.length,
                is_active: true
            };

            const response: any = await axios.post(PRIZE_DRAW_FEATURED_WINNER_ENDPOINT, payload, { headers });
            if (response.data) {
                setFeaturedWinners(prev => [...prev, response.data]);
                setNewFeaturedName('');
                setNewFeaturedAmount('');
                notify("Featured winner added", "info");
            }
        } catch (error) {
            console.error("Failed to add featured winner:", error);
            notify("Failed to add featured winner", "warning");
        } finally {
            setIsSavingFeatured(false);
        }
    };

    const handleDeleteFeaturedWinner = async (winnerId: number) => {
        if (!window.confirm("Are you sure you want to remove this featured winner?")) return;
        try {
            const headers = getConfigPatch();
            await axios.delete(`${PRIZE_DRAW_FEATURED_WINNER_ENDPOINT}/${winnerId}`, { headers });
            setFeaturedWinners(prev => prev.filter(w => w.id !== winnerId));
            notify("Featured winner removed", "info");
        } catch (error) {
            console.error("Failed to delete featured winner:", error);
            notify("Failed to delete featured winner", "warning");
        }
    };

    if (initialLoading) {
        return (
            <div className={classes.loadingContainer}>
                <CircularProgress />
            </div>
        );
    }

    return (
        <Form onSubmit={handleSubmit} initialValues={initialValues}>
            {({ handleSubmit, values }) => (
                <form onSubmit={handleSubmit}>
                    <div className={classes.main}>
                        {/* Header */}
                        <div className={classes.header}>
                            <Typography variant="h5" className={classes.title}>
                                Prize Draw Configuration
                            </Typography>
                            <div className={classes.headerActions}>
                                <FormControl variant="outlined" size="small" className={classes.campaignSelect}>
                                    <Select
                                        value={isCreatingNew ? 'new' : (selectedCampaignId || '')}
                                        onChange={handleCampaignChange}
                                        displayEmpty
                                    >
                                        <MenuItem value="" disabled>Select Campaign</MenuItem>
                                        {campaigns.map(c => (
                                            <MenuItem key={c.id} value={c.id}>
                                                {c.name} {c.is_active ? '(Active)' : ''}
                                            </MenuItem>
                                        ))}
                                        <MenuItem value="new">+ Create New Campaign</MenuItem>
                                    </Select>
                                </FormControl>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    type="submit"
                                    disabled={loading}
                                >
                                    {loading ? <CircularProgress size={24} /> : (isCreatingNew ? 'Create' : 'Save Changes')}
                                </Button>
                            </div>
                        </div>

                        {/* Mode Toggle Section */}
                        <div className={classes.modeToggleSection}>
                            <div className={classes.modeToggleInfo}>
                                <EmojiEventsIcon className={classes.modeIcon} />
                                <div>
                                    <Typography variant="h6">Prize Draw Mode</Typography>
                                    <Typography variant="body2" color="textSecondary">
                                        When enabled, referrals earn tickets for weekly prize draws instead of flat rewards
                                    </Typography>
                                </div>
                            </div>
                            <div>
                                <Field
                                    name="is_prize_draw_enabled"
                                    type="checkbox"
                                    component={renderSwitch}
                                    label="Enable Prize Draw"
                                />
                                <Field
                                    name="disable_after_current_week"
                                    type="checkbox"
                                    component={renderSwitch}
                                    label="Disable After Current Week"
                                />
                            </div>
                        </div>

                        {/* Campaign Settings */}
                        <Accordion
                            expanded={expandedSections.includes("campaign")}
                            onChange={handleAccordionChange("campaign")}
                            className={classes.accordion}
                        >
                            <AccordionSummary expandIcon={<ExpandMoreIcon />} className={classes.accordionSummary}>
                                <SettingsIcon className={classes.sectionIcon} />
                                <Typography className={classes.sectionTitle}>Campaign Settings</Typography>
                                <Typography className={classes.sectionDescription}>Name, dates, priority</Typography>
                            </AccordionSummary>
                            <AccordionDetails className={classes.accordionDetails}>
                                <div className={classes.fieldGrid}>
                                    <Field name="name" component={renderInput} label="Campaign Name" placeholder="e.g., Summer Prize Draw" />
                                    <Field name="start_date" component={renderDateInput} label="Start Date" />
                                    <Field name="end_date" component={renderDateInput} label="End Date" />
                                    <Field name="priority" component={renderNumberInput} label="Priority" placeholder="100" />
                                    <Field name="is_active" type="checkbox" component={renderSwitch} label="Active" />
                                </div>
                            </AccordionDetails>
                        </Accordion>

                        {/* Budget Settings */}
                        <Accordion
                            expanded={expandedSections.includes("budget")}
                            onChange={handleAccordionChange("budget")}
                            className={classes.accordion}
                        >
                            <AccordionSummary expandIcon={<ExpandMoreIcon />} className={classes.accordionSummary}>
                                <MonetizationOnIcon className={classes.sectionIcon} />
                                <Typography className={classes.sectionTitle}>Budget Settings</Typography>
                                <Typography className={classes.sectionDescription}>Weekly budget and fallback prizes</Typography>
                            </AccordionSummary>
                            <AccordionDetails className={classes.accordionDetails}>
                                <div className={classes.fieldGrid}>
                                    <Field name="weekly_budget" component={renderCurrencyInput} label="Weekly Budget" placeholder="2500" />
                                    <Field name="fallback_prize_amount" component={renderCurrencyInput} label="Fallback Prize Amount" placeholder="5" />
                                    <Field name="fallback_enabled" type="checkbox" component={renderSwitch} label="Fallback Enabled" />
                                    <Field name="boost_only_after_budget" type="checkbox" component={renderSwitch} label="Boost Only After Budget Exhausted" />
                                    <Field name="top_prize_threshold" component={renderCurrencyInput} label="Top Prize Threshold (Monthly Limit)" placeholder="10" />
                                </div>

                                {/* Participation Mode Section */}
                                <div style={{ marginTop: 24, padding: 16, backgroundColor: 'rgba(218, 41, 114, 0.05)', borderRadius: 12, border: '1px solid rgba(218, 41, 114, 0.2)' }}>
                                    <Typography variant="subtitle1" style={{ fontWeight: 600, marginBottom: 12, color: '#DA2972' }}>
                                        <span role="img" aria-label="ticket">🎫</span> Participation Mode
                                    </Typography>
                                    <Typography variant="body2" color="textSecondary" style={{ marginBottom: 16 }}>
                                        When enabled, everyone gets £X per ticket, and admin manually assigns top 4 prizes (£1000, £500, £250, £100).
                                        Top prizes REPLACE the base prize (not add to it).
                                    </Typography>
                                    <div className={classes.fieldGrid}>
                                        <Field name="participation_mode" type="checkbox" component={renderSwitch} label="Enable Participation Mode" />
                                        <Field name="base_prize_per_ticket" component={renderCurrencyInput} label="Base Prize Per Ticket" placeholder="5" />
                                    </div>
                                </div>
                            </AccordionDetails>
                        </Accordion>

                        {/* Prize Tiers */}
                        <Accordion
                            expanded={expandedSections.includes("tiers")}
                            onChange={handleAccordionChange("tiers")}
                            className={classes.accordion}
                        >
                            <AccordionSummary expandIcon={<ExpandMoreIcon />} className={classes.accordionSummary}>
                                <EmojiEventsIcon className={classes.sectionIcon} />
                                <Typography className={classes.sectionTitle}>Prize Tiers</Typography>
                                <Typography className={classes.sectionDescription}>Configure prize amounts and winners</Typography>
                            </AccordionSummary>
                            <AccordionDetails className={classes.accordionDetails}>
                                <div style={{ display: 'flex', gap: 16, marginBottom: 16 }}>
                                    <Button
                                        variant="outlined"
                                        color="primary"
                                        startIcon={<AddIcon />}
                                        onClick={() => {
                                            setEditingTier({
                                                tier_rank: prizeTiers.length + 1,
                                                prize_amount: 0,
                                                winner_count: 1,
                                                min_tickets_for_eligibility: 1,
                                                ticket_weight_multiplier: 1,
                                                display_label: '',
                                                display_color: '#4CAF50',
                                                is_top_prize: false
                                            });
                                            setTierDialogOpen(true);
                                        }}
                                        disabled={!configId}
                                    >
                                        Add Prize Tier
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={() => {
                                            const defaultTiers: PrizeTier[] = [
                                                { tier_rank: 1, display_label: 'Grand Prize', prize_amount: 1000, winner_count: 1, min_tickets_for_eligibility: 1, ticket_weight_multiplier: 1, display_color: '#FFD700', is_top_prize: true },
                                                { tier_rank: 2, display_label: '2nd Prize', prize_amount: 500, winner_count: 1, min_tickets_for_eligibility: 1, ticket_weight_multiplier: 1, display_color: '#C0C0C0', is_top_prize: true },
                                                { tier_rank: 3, display_label: '3rd Prize', prize_amount: 250, winner_count: 1, min_tickets_for_eligibility: 1, ticket_weight_multiplier: 1, display_color: '#CD7F32', is_top_prize: true },
                                                { tier_rank: 4, display_label: '4th Prize', prize_amount: 100, winner_count: 2, min_tickets_for_eligibility: 1, ticket_weight_multiplier: 1, display_color: '#4CAF50', is_top_prize: true },
                                                { tier_rank: 5, display_label: '5th Prize', prize_amount: 50, winner_count: 3, min_tickets_for_eligibility: 1, ticket_weight_multiplier: 1, display_color: '#2196F3', is_top_prize: false },
                                                { tier_rank: 6, display_label: '6th Prize', prize_amount: 25, winner_count: 5, min_tickets_for_eligibility: 1, ticket_weight_multiplier: 1, display_color: '#9C27B0', is_top_prize: false },
                                                { tier_rank: 7, display_label: '7th Prize', prize_amount: 10, winner_count: 10, min_tickets_for_eligibility: 1, ticket_weight_multiplier: 1, display_color: '#FF5722', is_top_prize: false },
                                                { tier_rank: 8, display_label: '8th Prize', prize_amount: 5, winner_count: 20, min_tickets_for_eligibility: 1, ticket_weight_multiplier: 1, display_color: '#607D8B', is_top_prize: false },
                                            ];
                                            setPrizeTiers(defaultTiers);
                                            notify('Default tiers added. Click Edit on each to save, or edit values first.');
                                        }}
                                        disabled={prizeTiers.length > 0}
                                    >
                                        Create Default Tiers
                                    </Button>
                                </div>
                                {!configId && (
                                    <Typography variant="body2" color="textSecondary" style={{ marginBottom: 16 }}>
                                        Save the configuration first to add prize tiers
                                    </Typography>
                                )}
                                <TableContainer component={Paper} className={classes.tierTable}>
                                    <Table size="small">
                                        <TableHead className={classes.tierTableHeader}>
                                            <TableRow>
                                                <TableCell>Rank</TableCell>
                                                <TableCell>Label</TableCell>
                                                <TableCell>Prize Amount</TableCell>
                                                <TableCell>Winners</TableCell>
                                                <TableCell>Min Tickets</TableCell>
                                                <TableCell>Weight</TableCell>
                                                <TableCell>Top Prize</TableCell>
                                                <TableCell>Color</TableCell>
                                                <TableCell>Actions</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {prizeTiers.map((tier, index) => (
                                                <TableRow key={tier.id || `unsaved-${index}`} style={{ backgroundColor: !tier.id ? '#fff3e0' : 'inherit' }}>
                                                    <TableCell>{tier.tier_rank}</TableCell>
                                                    <TableCell>
                                                        {tier.display_label}
                                                        {!tier.id && <span style={{ color: '#ff9800', marginLeft: 8, fontSize: '0.75rem' }}>(unsaved)</span>}
                                                    </TableCell>
                                                    <TableCell>£{tier.prize_amount}</TableCell>
                                                    <TableCell>{tier.winner_count}</TableCell>
                                                    <TableCell>{tier.min_tickets_for_eligibility}</TableCell>
                                                    <TableCell>{tier.ticket_weight_multiplier}x</TableCell>
                                                    <TableCell>{tier.is_top_prize ? 'Yes' : 'No'}</TableCell>
                                                    <TableCell>
                                                        <span
                                                            className={classes.colorPreview}
                                                            style={{ backgroundColor: tier.display_color }}
                                                        />
                                                    </TableCell>
                                                    <TableCell>
                                                        <IconButton
                                                            size="small"
                                                            onClick={() => {
                                                                setEditingTier(tier);
                                                                setTierDialogOpen(true);
                                                            }}
                                                        >
                                                            <EditIcon fontSize="small" />
                                                        </IconButton>
                                                        <IconButton
                                                            size="small"
                                                            onClick={() => {
                                                                if (tier.id) {
                                                                    handleTierDelete(tier.id);
                                                                } else {
                                                                    // Remove unsaved tier from local state
                                                                    setPrizeTiers(prev => prev.filter((_, i) => i !== index));
                                                                }
                                                            }}
                                                        >
                                                            <DeleteIcon fontSize="small" />
                                                        </IconButton>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                            {prizeTiers.length === 0 && (
                                                <TableRow>
                                                    <TableCell colSpan={9} align="center">
                                                        No prize tiers configured
                                                    </TableCell>
                                                </TableRow>
                                            )}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                {prizeTiers.some(t => !t.id) && configId && (
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={async () => {
                                            const unsavedTiers = prizeTiers.filter(t => !t.id);
                                            if (unsavedTiers.length === 0) return;
                                            try {
                                                setLoading(true);
                                                const headers = getConfigPost();
                                                for (const tier of unsavedTiers) {
                                                    await axios.post(PRIZE_DRAW_TIER_ENDPOINT, { ...tier, config_id: configId }, { headers });
                                                }
                                                // Refetch all tiers
                                                const tierConfig = getConfigGet({ config_id: configId });
                                                const tierResponse: any = await axios.get(PRIZE_DRAW_TIER_ENDPOINT, tierConfig);
                                                if (tierResponse.data?.data) {
                                                    setPrizeTiers(tierResponse.data.data.sort((a: PrizeTier, b: PrizeTier) => a.tier_rank - b.tier_rank));
                                                }
                                                notify(`${unsavedTiers.length} tiers saved successfully`);
                                            } catch (error: any) {
                                                notify(error.response?.data?.message || 'Failed to save tiers', 'warning');
                                            } finally {
                                                setLoading(false);
                                            }
                                        }}
                                        style={{ marginTop: 16 }}
                                    >
                                        Save All Unsaved Tiers ({prizeTiers.filter(t => !t.id).length})
                                    </Button>
                                )}
                            </AccordionDetails>
                        </Accordion>

                        {/* Ambassador Settings */}
                        <Accordion
                            expanded={expandedSections.includes("ambassador")}
                            onChange={handleAccordionChange("ambassador")}
                            className={classes.accordion}
                        >
                            <AccordionSummary expandIcon={<ExpandMoreIcon />} className={classes.accordionSummary}>
                                <PeopleIcon className={classes.sectionIcon} />
                                <Typography className={classes.sectionTitle}>Ambassador Settings</Typography>
                                <Typography className={classes.sectionDescription}>Threshold and flat reward for ambassadors</Typography>
                            </AccordionSummary>
                            <AccordionDetails className={classes.accordionDetails}>
                                <div className={classes.fieldGrid}>
                                    <Field name="ambassador_threshold" component={renderNumberInput} label="Ambassador Threshold (referrals)" placeholder="10" />
                                    <Field name="ambassador_flat_reward" component={renderCurrencyInput} label="Ambassador Flat Reward" placeholder="10" />
                                </div>
                                <Typography variant="body2" color="textSecondary" style={{ marginTop: 16 }}>
                                    Users with {values.ambassador_threshold || 10}+ successful referrals become Ambassadors and receive £{values.ambassador_flat_reward || 10} per referral instead of prize draw tickets.
                                </Typography>
                            </AccordionDetails>
                        </Accordion>

                        {/* Boost Settings */}
                        <Accordion
                            expanded={expandedSections.includes("boost")}
                            onChange={handleAccordionChange("boost")}
                            className={classes.accordion}
                        >
                            <AccordionSummary expandIcon={<ExpandMoreIcon />} className={classes.accordionSummary}>
                                <WhatshotIcon className={classes.sectionIcon} />
                                <Typography className={classes.sectionTitle}>Boost Settings</Typography>
                                <Typography className={classes.sectionDescription}>Boost weeks earned per ticket</Typography>
                            </AccordionSummary>
                            <AccordionDetails className={classes.accordionDetails}>
                                <div className={classes.fieldGrid}>
                                    <Field name="boost_weeks_per_ticket" component={renderNumberInput} label="Boost Weeks Per Ticket" placeholder="1" />
                                    <Field name="max_boost_weeks" component={renderNumberInput} label="Max Boost Weeks" placeholder="10" />
                                    <Field name="boost_haircut_percentage" component={renderNumberInput} label="Boost Haircut %" placeholder="0" />
                                </div>
                                <Typography variant="body2" color="textSecondary" style={{ marginTop: 16 }}>
                                    Every ticket earns {values.boost_weeks_per_ticket || 1} boost week(s), up to a maximum of {values.max_boost_weeks || 10} weeks.
                                </Typography>
                            </AccordionDetails>
                        </Accordion>

                        {/* Multiplier Settings */}
                        <Accordion
                            expanded={expandedSections.includes("multiplier")}
                            onChange={handleAccordionChange("multiplier")}
                            className={classes.accordion}
                        >
                            <AccordionSummary expandIcon={<ExpandMoreIcon />} className={classes.accordionSummary}>
                                <TrendingUpIcon className={classes.sectionIcon} />
                                <Typography className={classes.sectionTitle}>Multiplier Event</Typography>
                                <Typography className={classes.sectionDescription}>2x/3x ticket events</Typography>
                            </AccordionSummary>
                            <AccordionDetails className={classes.accordionDetails}>
                                <div className={classes.fieldGrid}>
                                    <Field name="current_multiplier" component={renderNumberInput} label="Current Multiplier" placeholder="1" />
                                    <Field name="multiplier_start_date" component={renderDateInput} label="Multiplier Start Date" />
                                    <Field name="multiplier_end_date" component={renderDateInput} label="Multiplier End Date" />
                                </div>
                                {(values.current_multiplier || 1) > 1 && (
                                    <Typography variant="body2" style={{ marginTop: 16, color: '#2e7d32', fontWeight: 500 }}>
                                        {values.current_multiplier}x MULTIPLIER ACTIVE - Each referral earns {values.current_multiplier} tickets!
                                    </Typography>
                                )}
                            </AccordionDetails>
                        </Accordion>

                        {/* Schedule Settings */}
                        <Accordion
                            expanded={expandedSections.includes("schedule")}
                            onChange={handleAccordionChange("schedule")}
                            className={classes.accordion}
                        >
                            <AccordionSummary expandIcon={<ExpandMoreIcon />} className={classes.accordionSummary}>
                                <ScheduleIcon className={classes.sectionIcon} />
                                <Typography className={classes.sectionTitle}>Schedule Settings</Typography>
                                <Typography className={classes.sectionDescription}>Weekly cycle timing</Typography>
                            </AccordionSummary>
                            <AccordionDetails className={classes.accordionDetails}>
                                <div className={classes.fieldGrid}>
                                    <FormControl variant="outlined" size="small" fullWidth>
                                        <Typography variant="caption" style={{ color: '#666', marginBottom: 4 }}>Week Start Day</Typography>
                                        <Field name="week_start_day">
                                            {({ input }: any) => (
                                                <Select {...input} variant="outlined">
                                                    <MenuItem value={0}>Sunday</MenuItem>
                                                    <MenuItem value={1}>Monday</MenuItem>
                                                    <MenuItem value={2}>Tuesday</MenuItem>
                                                    <MenuItem value={3}>Wednesday</MenuItem>
                                                    <MenuItem value={4}>Thursday</MenuItem>
                                                    <MenuItem value={5}>Friday</MenuItem>
                                                    <MenuItem value={6}>Saturday</MenuItem>
                                                </Select>
                                            )}
                                        </Field>
                                    </FormControl>
                                    <Field name="week_start_time" component={renderTimeInput} label="Week Start Time" />
                                    <Field name="draw_time" component={renderTimeInput} label="Draw Time (Monday)" />
                                    <Field name="announcement_time" component={renderTimeInput} label="Announcement Time" />
                                </div>
                                <Typography variant="body2" color="textSecondary" style={{ marginTop: 16 }}>
                                    Week cycle: Monday {values.week_start_time || '07:00'} - Saturday 23:59 (entries) → Sunday (grace period) → Monday {values.draw_time || '00:00'} (draw) → Monday {values.announcement_time || '06:00'} (announce)
                                </Typography>
                            </AccordionDetails>
                        </Accordion>

                        {/* Draw Management */}
                        <Accordion
                            expanded={expandedSections.includes("drawManagement")}
                            onChange={(e, expanded) => {
                                handleAccordionChange("drawManagement")(e, expanded);
                                if (expanded && configId) {
                                    fetchCurrentWeek();
                                }
                            }}
                            className={classes.accordion}
                        >
                            <AccordionSummary expandIcon={<ExpandMoreIcon />} className={classes.accordionSummary}>
                                <PlayArrowIcon className={classes.sectionIcon} style={{ color: '#1976d2' }} />
                                <Typography className={classes.sectionTitle}>Draw Management</Typography>
                                <Typography className={classes.sectionDescription}>Run and manage weekly draws</Typography>
                            </AccordionSummary>
                            <AccordionDetails className={classes.accordionDetails}>
                                <div className={classes.drawManagementContainer}>
                                    {/* Current Week Status */}
                                    {currentWeek ? (
                                        <div className={classes.drawStatusCard}>
                                            <div className={classes.drawStatusHeader}>
                                                <div>
                                                    <Typography variant="h6">
                                                        Week {currentWeek.week_number}, {currentWeek.year}
                                                    </Typography>
                                                    <Typography variant="body2" color="textSecondary">
                                                        {new Date(currentWeek.start_date).toLocaleDateString()} - {new Date(currentWeek.end_date).toLocaleDateString()}
                                                    </Typography>
                                                </div>
                                                <span
                                                    className={classes.drawStatusBadge}
                                                    style={{
                                                        backgroundColor: getStatusColor(currentWeek.status || 'active').bg,
                                                        color: getStatusColor(currentWeek.status || 'active').color
                                                    }}
                                                >
                                                    {String(currentWeek.status || 'active').replace(/_/g, ' ').toUpperCase()}
                                                </span>
                                            </div>

                                            <div className={classes.drawStatsGrid}>
                                                <div className={classes.drawStatBox}>
                                                    <div className={classes.drawStatValue}>{currentWeek.total_participants || 0}</div>
                                                    <div className={classes.drawStatLabel}>Participants</div>
                                                </div>
                                                <div className={classes.drawStatBox}>
                                                    <div className={classes.drawStatValue}>{currentWeek.total_entries || 0}</div>
                                                    <div className={classes.drawStatLabel}>Total Tickets</div>
                                                </div>
                                                <div className={classes.drawStatBox}>
                                                    <div className={classes.drawStatValue}>£{parseFloat(String(currentWeek.total_budget || 0)).toFixed(0)}</div>
                                                    <div className={classes.drawStatLabel}>Budget</div>
                                                </div>
                                                <div className={classes.drawStatBox}>
                                                    <div className={classes.drawStatValue}>{currentWeek.multiplier}x</div>
                                                    <div className={classes.drawStatLabel}>Multiplier</div>
                                                </div>
                                            </div>

                                            {/* Action Buttons */}
                                            <div className={classes.drawActionButtons}>
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    startIcon={isRunningDraw ? <CircularProgress size={20} color="inherit" /> : <PlayArrowIcon />}
                                                    onClick={handleRunDraw}
                                                    disabled={isRunningDraw || currentWeek.status === 'draw_confirmed' || currentWeek.status === 'announced' || currentWeek.status === 'completed'}
                                                >
                                                    {isRunningDraw ? 'Running Draw...' : 'Run Draw'}
                                                </Button>
                                                <Button
                                                    variant="outlined"
                                                    startIcon={<RefreshIcon />}
                                                    onClick={fetchCurrentWeek}
                                                >
                                                    Refresh
                                                </Button>
                                                <Button
                                                    variant="outlined"
                                                    startIcon={<HistoryIcon />}
                                                    onClick={handleOpenArchive}
                                                    style={{ marginLeft: 'auto' }}
                                                >
                                                    View Archive
                                                </Button>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className={classes.drawStatusCard}>
                                            <Typography variant="body1" color="textSecondary">
                                                No active week found. Save a campaign configuration first, then a week will be created automatically on Monday 07:00.
                                            </Typography>
                                            <Button
                                                variant="outlined"
                                                startIcon={<RefreshIcon />}
                                                onClick={fetchCurrentWeek}
                                                style={{ marginTop: 16 }}
                                            >
                                                Check for Week
                                            </Button>
                                        </div>
                                    )}

                                    {/* Warnings */}
                                    {drawWarnings.length > 0 && (
                                        <div>
                                            {drawWarnings.map((warning, idx) => (
                                                <div key={idx} className={classes.warningBanner}>
                                                    <WarningIcon style={{ color: '#e65100' }} />
                                                    <Typography variant="body2">{warning.message}</Typography>
                                                </div>
                                            ))}
                                        </div>
                                    )}

                                    {/* Draw Summary */}
                                    {drawSummary && (
                                        <div className={classes.drawStatusCard}>
                                            <Typography variant="h6" style={{ marginBottom: 16 }}>Draw Summary</Typography>
                                            <div className={classes.drawStatsGrid}>
                                                <div className={classes.drawStatBox}>
                                                    <div className={classes.drawStatValue}>{drawSummary.totalParticipants}</div>
                                                    <div className={classes.drawStatLabel}>Total Participants</div>
                                                </div>
                                                <div className={classes.drawStatBox}>
                                                    <div className={classes.drawStatValue}>£{(drawSummary.totalSpend || 0).toFixed(2)}</div>
                                                    <div className={classes.drawStatLabel}>Total Spend</div>
                                                </div>
                                                <div className={classes.drawStatBox}>
                                                    <div className={classes.drawStatValue}>£{(drawSummary.budgetRemaining || 0).toFixed(2)}</div>
                                                    <div className={classes.drawStatLabel}>Budget Remaining</div>
                                                </div>
                                                <div className={classes.drawStatBox}>
                                                    <div className={classes.drawStatValue}>{drawSummary.byTier?.length || 0}</div>
                                                    <div className={classes.drawStatLabel}>Active Tiers</div>
                                                </div>
                                            </div>

                                            {/* Tier Breakdown */}
                                            {drawSummary.byTier && drawSummary.byTier.length > 0 && (
                                                <TableContainer component={Paper} style={{ marginTop: 16 }}>
                                                    <Table size="small">
                                                        <TableHead>
                                                            <TableRow style={{ backgroundColor: '#f5f5f5' }}>
                                                                <TableCell>Tier</TableCell>
                                                                <TableCell>Prize</TableCell>
                                                                <TableCell>Winners</TableCell>
                                                                <TableCell>Total</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {drawSummary.byTier.map((tier) => (
                                                                <TableRow key={tier.tierRank}>
                                                                    <TableCell>{tier.tierLabel}</TableCell>
                                                                    <TableCell>£{tier.prizeAmount}</TableCell>
                                                                    <TableCell>{tier.winners}</TableCell>
                                                                    <TableCell>£{tier.totalSpend.toFixed(2)}</TableCell>
                                                                </TableRow>
                                                            ))}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            )}
                                        </div>
                                    )}

                                    {/* Top Winners Table (Editable) */}
                                    {preliminaryResults.length > 0 && (
                                        <div className={classes.drawStatusCard}>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                                                <div>
                                                    <Typography variant="h6">
                                                        {isParticipationMode
                                                            ? `Participation Mode - All Participants (${preliminaryResults.length})`
                                                            : `Top Winners - Review & Edit (${preliminaryResults.length} editable)`
                                                        }
                                                    </Typography>
                                                    {isParticipationMode && (
                                                        <Typography variant="body2" color="textSecondary">
                                                            Everyone gets base prize (£{values.base_prize_per_ticket} × tickets). Select 4 users below to assign top prizes: £{participationTopPrizes.join(', £')}
                                                        </Typography>
                                                    )}
                                                </div>
                                                {!drawCompleted && (
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        startIcon={isConfirmingDraw ? <CircularProgress size={20} color="inherit" /> : <CheckCircleIcon />}
                                                        onClick={handleConfirmDraw}
                                                        disabled={isConfirmingDraw}
                                                        style={{ backgroundColor: isConfirmingDraw ? '#ff8f00' : '#2e7d32' }}
                                                    >
                                                        {isConfirmingDraw
                                                            ? (processingStatus?.progress
                                                                ? `Processing ${processingStatus.progress.processed || 0}/${processingStatus.progress.total || 0}...`
                                                                : 'Queuing...')
                                                            : 'Confirm Draw'}
                                                    </Button>
                                                )}
                                            </div>

                                            {/* Processing Progress */}
                                            {processingStatus && !drawCompleted && (
                                                <div style={{
                                                    padding: '12px 16px',
                                                    backgroundColor: '#fff8e1',
                                                    borderRadius: 8,
                                                    marginBottom: 16,
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: 12
                                                }}>
                                                    <CircularProgress size={20} style={{ color: '#ff8f00' }} />
                                                    <div>
                                                        <Typography variant="body2" style={{ fontWeight: 500, color: '#e65100' }}>
                                                            Processing winners...
                                                        </Typography>
                                                        {processingStatus.progress && (
                                                            <Typography variant="caption" style={{ color: '#666' }}>
                                                                {processingStatus.progress.processed || 0} / {processingStatus.progress.total || 0} processed
                                                            </Typography>
                                                        )}
                                                    </div>
                                                </div>
                                            )}

                                            {drawCompleted && (
                                                <div className={classes.successBanner}>
                                                    <CheckCircleIcon style={{ color: '#2e7d32' }} />
                                                    <Typography variant="body2" style={{ color: '#2e7d32' }}>
                                                        Draw confirmed! Results saved and notifications scheduled.
                                                    </Typography>
                                                </div>
                                            )}

                                            <TableContainer component={Paper}>
                                                <Table size="small">
                                                    <TableHead>
                                                        <TableRow style={{ backgroundColor: '#f5f5f5' }}>
                                                            <TableCell>#</TableCell>
                                                            <TableCell>User</TableCell>
                                                            <TableCell>Email</TableCell>
                                                            <TableCell>Tickets</TableCell>
                                                            <TableCell>Tier</TableCell>
                                                            <TableCell>Prize</TableCell>
                                                            <TableCell>Boost</TableCell>
                                                            <TableCell>Flags</TableCell>
                                                            {!drawCompleted && <TableCell>Actions</TableCell>}
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {preliminaryResults.map((result, idx) => (
                                                            <TableRow key={result.userId} className={classes.winnerRow}>
                                                                <TableCell>{idx + 1}</TableCell>
                                                                <TableCell>{result.userName}</TableCell>
                                                                <TableCell>{result.userEmail}</TableCell>
                                                                <TableCell>{result.effectiveTickets}</TableCell>
                                                                <TableCell>
                                                                    <span style={{
                                                                        padding: '2px 8px',
                                                                        borderRadius: 12,
                                                                        fontSize: 12,
                                                                        backgroundColor: isParticipationMode
                                                                            ? (result.prizeAmount !== result.basePrize ? '#DA2972' : '#e3f2fd')
                                                                            : ((result.tierRank || 0) <= 3 ? '#fff3e0' : '#e3f2fd'),
                                                                        color: isParticipationMode
                                                                            ? (result.prizeAmount !== result.basePrize ? '#fff' : '#1565c0')
                                                                            : ((result.tierRank || 0) <= 3 ? '#e65100' : '#1565c0')
                                                                    }}>
                                                                        {isParticipationMode
                                                                            ? (result.prizeAmount !== result.basePrize ? 'Edited' : `#${result.rank || '-'}`)
                                                                            : result.tierLabel
                                                                        }
                                                                    </span>
                                                                </TableCell>
                                                                <TableCell style={{ fontWeight: 600 }}>£{result.prizeAmount}</TableCell>
                                                                <TableCell>+{result.boostWeeks}w</TableCell>
                                                                <TableCell>
                                                                    {result.hasWonThisMonth && (
                                                                        <span className={classes.monthlyWinnerChip}>Won this month</span>
                                                                    )}
                                                                </TableCell>
                                                                {!drawCompleted && (
                                                                    <TableCell>
                                                                        <IconButton
                                                                            size="small"
                                                                            onClick={() => handleOpenAdjustDialog(result)}
                                                                            title="Adjust winner tier"
                                                                        >
                                                                            <EditIcon fontSize="small" />
                                                                        </IconButton>
                                                                    </TableCell>
                                                                )}
                                                            </TableRow>
                                                        ))}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </div>
                                    )}

                                    {/* Recently Completed Week */}
                                    {recentlyCompletedWeek && (
                                        <div className={classes.drawStatusCard} style={{ borderLeft: '4px solid #4caf50' }}>
                                            <div className={classes.drawStatusHeader}>
                                                <div>
                                                    <Typography variant="h6" style={{ color: '#2e7d32' }}>
                                                        Recently Completed: Week {recentlyCompletedWeek.week_number}, {recentlyCompletedWeek.year}
                                                    </Typography>
                                                    <Typography variant="body2" color="textSecondary">
                                                        {new Date(recentlyCompletedWeek.start_date).toLocaleDateString()} - {new Date(recentlyCompletedWeek.end_date).toLocaleDateString()}
                                                    </Typography>
                                                </div>
                                                <span
                                                    className={classes.drawStatusBadge}
                                                    style={{ backgroundColor: '#e8f5e9', color: '#2e7d32' }}
                                                >
                                                    {String(recentlyCompletedWeek.status || 'completed').replace(/_/g, ' ').toUpperCase()}
                                                </span>
                                            </div>

                                            <div className={classes.drawStatsGrid}>
                                                <div className={classes.drawStatBox}>
                                                    <div className={classes.drawStatValue}>{recentlyCompletedWeek.total_participants || 0}</div>
                                                    <div className={classes.drawStatLabel}>Participants</div>
                                                </div>
                                                <div className={classes.drawStatBox}>
                                                    <div className={classes.drawStatValue}>{recentlyCompletedWeek.total_entries || 0}</div>
                                                    <div className={classes.drawStatLabel}>Total Tickets</div>
                                                </div>
                                                <div className={classes.drawStatBox}>
                                                    <div className={classes.drawStatValue}>£{parseFloat(String(recentlyCompletedWeek.total_spent || 0)).toFixed(0)}</div>
                                                    <div className={classes.drawStatLabel}>Total Spent</div>
                                                </div>
                                                <div className={classes.drawStatBox}>
                                                    <div className={classes.drawStatValue}>{recentlyCompletedResults.length}</div>
                                                    <div className={classes.drawStatLabel}>Winners</div>
                                                </div>
                                            </div>

                                            {/* Winners Table (Read-only) */}
                                            {recentlyCompletedResults.length > 0 && (
                                                <TableContainer component={Paper} style={{ marginTop: 16 }}>
                                                    <Table size="small">
                                                        <TableHead>
                                                            <TableRow style={{ backgroundColor: '#e8f5e9' }}>
                                                                <TableCell>#</TableCell>
                                                                <TableCell>User</TableCell>
                                                                <TableCell>Tier</TableCell>
                                                                <TableCell>Prize</TableCell>
                                                                <TableCell>Boost</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {recentlyCompletedResults.slice(0, 10).map((result, idx) => (
                                                                <TableRow key={result.userId}>
                                                                    <TableCell>{idx + 1}</TableCell>
                                                                    <TableCell>{result.userName}</TableCell>
                                                                    <TableCell>
                                                                        <span style={{
                                                                            padding: '2px 8px',
                                                                            borderRadius: 12,
                                                                            fontSize: 12,
                                                                            backgroundColor: '#e8f5e9',
                                                                            color: '#2e7d32'
                                                                        }}>
                                                                            {result.tierLabel}
                                                                        </span>
                                                                    </TableCell>
                                                                    <TableCell style={{ fontWeight: 600 }}>£{result.prizeAmount}</TableCell>
                                                                    <TableCell>+{result.boostWeeks}w</TableCell>
                                                                </TableRow>
                                                            ))}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            )}
                                            {recentlyCompletedResults.length > 10 && (
                                                <Typography variant="caption" color="textSecondary" style={{ marginTop: 8, display: 'block' }}>
                                                    Showing top 10 of {recentlyCompletedResults.length} winners. Click "View Archive" for full details.
                                                </Typography>
                                            )}
                                        </div>
                                    )}

                                    {/* Help Text */}
                                    <Typography variant="body2" color="textSecondary" style={{ padding: 16, backgroundColor: '#f5f5f5', borderRadius: 8 }}>
                                        <strong>Manual Draw Process:</strong><br />
                                        1. Wait until draw window (after Sunday 00:00)<br />
                                        2. Click "Run Draw" to execute the weighted lottery algorithm<br />
                                        3. Review preliminary results - check for monthly winners, adjust if needed<br />
                                        4. Click "Confirm Draw" to finalize and schedule notifications<br />
                                        5. Notifications are sent at Monday 06:00 AM
                                    </Typography>
                                </div>
                            </AccordionDetails>
                        </Accordion>

                        {/* UAT Testing Mode */}
                        <Accordion
                            expanded={expandedSections.includes("uat")}
                            onChange={handleAccordionChange("uat")}
                            className={classes.accordion}
                        >
                            <AccordionSummary expandIcon={<ExpandMoreIcon />} className={classes.accordionSummary}>
                                <BugReportIcon className={classes.sectionIcon} style={{ color: '#ed6c02' }} />
                                <Typography className={classes.sectionTitle}>UAT Testing Mode</Typography>
                                <Typography className={classes.sectionDescription}>Override schedule for testing</Typography>
                            </AccordionSummary>
                            <AccordionDetails className={classes.accordionDetails}>
                                <div style={{ backgroundColor: '#fff3e0', padding: 16, borderRadius: 8, marginBottom: 16, border: '1px solid #ffcc80' }}>
                                    <Typography variant="body2" style={{ color: '#e65100', fontWeight: 500 }}>
                                        <span role="img" aria-label="warning">⚠️</span> UAT Mode overrides normal weekly schedule. Use for testing only!
                                    </Typography>
                                </div>
                                <div className={classes.fieldGrid}>
                                    <Field name="is_uat_mode" type="checkbox" component={renderSwitch} label="Enable UAT Mode" />
                                    <Field name="draw_interval_hours" component={renderNumberInput} label="Draw Interval (Hours)" placeholder="12" />
                                    <div>
                                        <Typography variant="caption" style={{ color: '#666', marginBottom: 4, display: 'block' }}>Next Draw Date/Time</Typography>
                                        <Field name="next_draw_datetime">
                                            {({ input }: any) => (
                                                <TextField
                                                    {...input}
                                                    type="datetime-local"
                                                    fullWidth
                                                    variant="outlined"
                                                    size="small"
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            )}
                                        </Field>
                                    </div>
                                </div>
                                <Typography variant="body2" color="textSecondary" style={{ marginTop: 16 }}>
                                    <strong>UAT Mode Behavior:</strong><br />
                                    • Draw Interval: Set to 12 for draws every 12 hours, 24 for daily draws<br />
                                    • Next Draw: Override to run a draw at a specific date/time<br />
                                    • After each draw, next draw = current draw time + interval hours
                                </Typography>
                                {values.is_uat_mode && (
                                    <div style={{ marginTop: 16, padding: 12, backgroundColor: '#e8f5e9', borderRadius: 8 }}>
                                        <Typography variant="body2" style={{ color: '#2e7d32' }}>
                                            ✓ UAT Mode is ENABLED - Draws will run every {values.draw_interval_hours || 24} hours
                                            {values.next_draw_datetime && (<><br />Next draw scheduled: {new Date(values.next_draw_datetime).toLocaleString()}</>)}
                                        </Typography>
                                    </div>
                                )}

                                {/* UAT Quick Actions - Only visible when UAT mode is enabled */}
                                {values.is_uat_mode && (
                                    <div style={{ marginTop: 24, padding: 16, backgroundColor: '#f5f5f5', borderRadius: 8, border: '1px dashed #999' }}>
                                        <Typography variant="subtitle2" style={{ marginBottom: 12, color: '#333' }}>
                                            UAT Quick Actions
                                        </Typography>

                                        {/* Current Week Status */}
                                        {currentWeek ? (
                                            <div style={{ marginBottom: 12, padding: 12, backgroundColor: '#e3f2fd', borderRadius: 4 }}>
                                                <Typography variant="body2">
                                                    <strong>Current Week:</strong> Week {currentWeek.week_number}/{currentWeek.year} |
                                                    Status: <strong>{currentWeek.status || 'active'}</strong> |
                                                    Participants: {currentWeek.total_participants || 0} |
                                                    Tickets: {currentWeek.total_entries || 0}
                                                </Typography>
                                            </div>
                                        ) : (
                                            <div style={{ marginBottom: 12, padding: 12, backgroundColor: '#fff3e0', borderRadius: 4 }}>
                                                <Typography variant="body2" style={{ color: '#e65100' }}>
                                                    No active week. Create one to start collecting entries.
                                                </Typography>
                                            </div>
                                        )}

                                        <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
                                            <Button
                                                variant="outlined"
                                                size="small"
                                                onClick={handleCreateTestWeek}
                                                disabled={isCreatingTestData}
                                            >
                                                {currentWeek ? 'Refresh Week' : 'Create Week Now'}
                                            </Button>
                                            <Button
                                                variant="contained"
                                                size="small"
                                                color="primary"
                                                onClick={handleStartNewWeek}
                                                disabled={isCreatingTestData || !currentWeek || !['draw_confirmed', 'completed'].includes(currentWeek.status)}
                                                style={{ marginLeft: 8 }}
                                            >
                                                Start New Week
                                            </Button>
                                            <Button
                                                variant="outlined"
                                                size="small"
                                                color="secondary"
                                                onClick={handleClearTestData}
                                                disabled={isCreatingTestData || !currentWeek}
                                            >
                                                Reset Week (Clear All Data)
                                            </Button>
                                        </div>

                                        <Typography variant="caption" color="textSecondary" style={{ display: 'block', marginTop: 12 }}>
                                            <strong>Manual Testing Flow:</strong><br />
                                            1. Create/ensure a week exists<br />
                                            2. Use real referral flow (share code → signup → first shop → ticket earned)<br />
                                            3. Go to "Draw Management" → Click "Run Draw" whenever ready<br />
                                            4. Review results → Adjust winners if needed → Confirm Draw<br />
                                            <br />
                                            <em>All times are in UK/London timezone (GMT/BST)</em>
                                        </Typography>
                                    </div>
                                )}
                            </AccordionDetails>
                        </Accordion>

                        {/* Screen Configuration */}
                        <Accordion
                            expanded={expandedSections.includes("screen")}
                            onChange={handleAccordionChange("screen")}
                            className={classes.accordion}
                        >
                            <AccordionSummary expandIcon={<ExpandMoreIcon />} className={classes.accordionSummary}>
                                <PhoneAndroidIcon className={classes.sectionIcon} />
                                <Typography className={classes.sectionTitle}>Screen Configuration</Typography>
                                <Typography className={classes.sectionDescription}>Customize prize draw screen text</Typography>
                            </AccordionSummary>
                            <AccordionDetails className={classes.accordionDetails}>
                                <div className={classes.screenPreviewContainer}>
                                    {/* Form Section */}
                                    <div className={classes.screenFormSection}>
                                        {/* Variation Selector */}
                                        <FormControl variant="outlined" className={classes.screenVariationSelect}>
                                            <Typography variant="caption" style={{ color: '#666', marginBottom: 4, display: 'block' }}>
                                                Select Screen State
                                            </Typography>
                                            <Select
                                                value={selectedScreenVariation}
                                                onChange={(e) => setSelectedScreenVariation(e.target.value as string)}
                                            >
                                                <MenuItem value="no_entry">No Entry (Default)</MenuItem>
                                                <MenuItem value="active_entry">Active Entry (Has Ticket)</MenuItem>
                                                <MenuItem value="pending_claim">Pending Claim (Draw Ended)</MenuItem>
                                                <MenuItem value="prize_claimed">Prize Claimed (Result)</MenuItem>
                                            </Select>
                                        </FormControl>

                                        {/* Dynamic Form Fields based on selection */}
                                        {selectedScreenVariation === 'no_entry' && (
                                            <>
                                                <Typography variant="subtitle2" style={{ fontWeight: 600, marginBottom: 4, color: '#1976d2' }}>
                                                    1. No Entry (Default)
                                                </Typography>
                                                <Typography variant="body2" color="textSecondary" style={{ marginBottom: 12, fontSize: 12 }}>
                                                    User has no ticket this week. Encourages referring to enter the draw.
                                                </Typography>
                                                <div className={classes.fieldGrid}>
                                                    <Field name="screen_config.no_entry.header" component={renderInput} label="Badge Text" placeholder="Exclusive to Sprive Plus" />
                                                    <Field name="screen_config.no_entry.title" component={renderInput} label="Title" placeholder="Earn boosts AND £5 to £1,000" />
                                                    <Field name="screen_config.no_entry.title2" component={renderInput} label="Title 2" placeholder="Every referral = 1 ticket" />
                                                    <Field name="screen_config.no_entry.subtitle" component={renderInput} label="Subtitle" placeholder="Your odds are better than you think..." />
                                                    <Field name="screen_config.no_entry.secondary_info" component={renderInput} label="Secondary Info (Ambassador)" placeholder="Anyone with 10+ referrals switches to our Sprive Ambassador program instead." />
                                                    <Field name="screen_config.no_entry.cta" component={renderInput} label="Primary CTA" placeholder="Refer a friend" />
                                                    <Field name="screen_config.no_entry.footer" component={renderInput} label="Footer" placeholder="All prizes overpay your mortgage. Read terms." />
                                                </div>
                                            </>
                                        )}

                                        {selectedScreenVariation === 'active_entry' && (
                                            <>
                                                <Typography variant="subtitle2" style={{ fontWeight: 600, marginBottom: 4, color: '#2e7d32' }}>
                                                    2. Active Entry (Has Ticket)
                                                </Typography>
                                                <Typography variant="body2" color="textSecondary" style={{ marginBottom: 12, fontSize: 12 }}>
                                                    User has ticket(s) for this week's draw. Shows countdown to draw time.
                                                </Typography>
                                                <div className={classes.fieldGrid}>
                                                    <Field name="screen_config.active_entry.title" component={renderInput} label="Title" placeholder="You're in! Draw in:" />
                                                    <Field name="screen_config.active_entry.title2" component={renderInput} label="Title 2" placeholder="You have {tickets} ticket(s)" />
                                                    <Field name="screen_config.active_entry.subtitle" component={renderInput} label="Subtitle" placeholder="Last week 12 winners won £1,850" />
                                                    <Field name="screen_config.active_entry.winner_highlight" component={renderInput} label="Winner Highlight" placeholder="Last week's £1k winner did {count} referrals" />
                                                    <Field name="screen_config.active_entry.cta" component={renderInput} label="CTA" placeholder="Double your chances" />
                                                    <Field name="screen_config.active_entry.footer" component={renderInput} label="Footer" placeholder="Next draw: Monday 7am" />
                                                </div>
                                            </>
                                        )}

                                        {selectedScreenVariation === 'pending_claim' && (
                                            <>
                                                <Typography variant="subtitle2" style={{ fontWeight: 600, marginBottom: 4, color: '#ed6c02' }}>
                                                    3. Pending Claim (Draw Ended)
                                                </Typography>
                                                <Typography variant="body2" color="textSecondary" style={{ marginBottom: 12, fontSize: 12 }}>
                                                    Draw has happened. User needs to tap to reveal their prize result.
                                                </Typography>
                                                <div className={classes.fieldGrid}>
                                                    <Field name="screen_config.pending_claim.title" component={renderInput} label="Title" placeholder="The results are in!" />
                                                    <Field name="screen_config.pending_claim.title2" component={renderInput} label="Title 2" placeholder="Tap to reveal your prize" />
                                                    <Field name="screen_config.pending_claim.subtitle" component={renderInput} label="Subtitle" placeholder="You had {tickets} ticket(s) this week" />
                                                    <Field name="screen_config.pending_claim.cta" component={renderInput} label="CTA" placeholder="Claim now" />
                                                    <Field name="screen_config.pending_claim.footer" component={renderInput} label="Footer" placeholder="Your result is waiting" />
                                                </div>
                                            </>
                                        )}

                                        {selectedScreenVariation === 'prize_claimed' && (
                                            <>
                                                <Typography variant="subtitle2" style={{ fontWeight: 600, marginBottom: 4, color: '#9c27b0' }}>
                                                    4. Prize Claimed (Result Shown)
                                                </Typography>
                                                <Typography variant="body2" color="textSecondary" style={{ marginBottom: 12, fontSize: 12 }}>
                                                    Prize revealed. Shown once, then displayed until user gets next week's ticket.
                                                </Typography>
                                                <div className={classes.fieldGrid}>
                                                    <Field name="screen_config.claimed.title" component={renderInput} label="Title (Winner)" placeholder="You won {amount}!" />
                                                    <Field name="screen_config.claimed.title2" component={renderInput} label="Title 2 (Winner)" placeholder="Added to your Sprive wallet" />
                                                    <Field name="screen_config.claimed.subtitle" component={renderInput} label="Subtitle (Winner)" placeholder="Congrats! Keep referring to win more." />
                                                    <Field name="screen_config.claimed.secondary_info" component={renderInput} label="Non-winner Title" placeholder="Better luck next time!" />
                                                    <Field name="screen_config.claimed.boost_badge" component={renderInput} label="Boost Badge" placeholder="+{weeks} weeks boost earned" />
                                                    <Field name="screen_config.claimed.footer" component={renderInput} label="Footer" placeholder="Next draw starts Monday" />
                                                </div>
                                            </>
                                        )}

                                        {/* Multiplier Mode (always shown at bottom) */}
                                        <div style={{ marginTop: 24, paddingTop: 24, borderTop: '1px solid #e0e0e0' }}>
                                            <Typography variant="subtitle2" style={{ fontWeight: 600, marginBottom: 4, color: '#d32f2f' }}>
                                                5. Multiplier Mode (2x/3x Condition)
                                            </Typography>
                                            <Typography variant="body2" color="textSecondary" style={{ marginBottom: 12, fontSize: 12 }}>
                                                When multiplier {'>'} 1, these override/append to text on ALL screens above.
                                            </Typography>
                                            <div className={classes.fieldGrid}>
                                                <Field name="screen_config.multiplier.badge_text" component={renderInput} label="Badge Text" placeholder="{multiplier}X TICKETS" />
                                                <Field name="screen_config.multiplier.header" component={renderInput} label="Header Override" placeholder="DOUBLE TICKETS EVENT" />
                                                <Field name="screen_config.multiplier.title_suffix" component={renderInput} label="Title Suffix" placeholder="(2X this week!)" />
                                            </div>
                                        </div>

                                        <Typography variant="body2" color="textSecondary" style={{ marginTop: 20, padding: 12, backgroundColor: '#f5f5f5', borderRadius: 4 }}>
                                            <strong>Variables:</strong> {'{amount}'}, {'{tickets}'}, {'{count}'}, {'{weeks}'}, {'{multiplier}'}
                                        </Typography>
                                    </div>

                                    {/* Live Preview - Matches Figma Design */}
                                    <div className={classes.screenPreview}>
                                        {/* Multiplier Badge (if multiplier > 1) */}
                                        {(values.current_multiplier || 1) > 1 && (
                                            <div className={classes.screenMultiplierBadge}>
                                                {(values.screen_config?.multiplier?.badge_text || '{multiplier}X TICKETS').replace('{multiplier}', String(values.current_multiplier || 2))}
                                            </div>
                                        )}

                                        {/* NO ENTRY SCREEN - Different Layout */}
                                        {selectedScreenVariation === 'no_entry' && (
                                            <>
                                                {/* Top Content - Badge + Title above chest */}
                                                <div className={classes.screenNoEntryContent}>
                                                    {/* Fire Icon with + badge */}
                                                    <div className={classes.screenBadgeIcon}>
                                                        <img src="/fireflash.gif" alt="" style={{ width: 32, height: 32 }} />
                                                        <div className={classes.screenBadgeIconPlus}>+</div>
                                                    </div>
                                                    {/* Badge Text */}
                                                    <span className={classes.screenBadgeText}>
                                                        {values.screen_config?.no_entry?.header || 'Exclusive to Sprive Plus'}
                                                    </span>
                                                    {/* Main Title */}
                                                    <div className={classes.screenNoEntryTitle}>
                                                        {values.screen_config?.no_entry?.title || 'Earn boosts AND £5 to £1,000'}
                                                        <span style={{ fontSize: 16, marginLeft: 4, verticalAlign: 'super', opacity: 0.7 }}>ⓘ</span>
                                                    </div>
                                                    {/* Title 2 - continuation of title, no gap */}
                                                    {values.screen_config?.no_entry?.title2 && (
                                                        <div className={classes.screenNoEntryTitle} style={{ marginTop: -8 }}>
                                                            {values.screen_config.no_entry.title2}
                                                        </div>
                                                    )}
                                                    {/* Subtitle */}
                                                    <div className={classes.screenNoEntrySubtitle}>
                                                        {values.screen_config?.no_entry?.subtitle || 'Your odds are better than you think...'}
                                                    </div>
                                                    {/* Subtitle 2 - Ambassador Info */}
                                                    <div className={classes.screenNoEntrySubtitle2}>
                                                        {values.screen_config?.no_entry?.secondary_info || 'Anyone with 10+ referrals switches to our Sprive Ambassador program instead.'}
                                                    </div>
                                                </div>

                                                {/* Chest with Coins */}
                                                <div className={classes.screenChestSection}>
                                                    <img src="/prize-chest.svg" alt="Prize Chest" className={classes.screenChestImage} />
                                                </div>

                                                {/* White Bottom Card */}
                                                <div className={classes.screenWhiteCard}>
                                                    <div className={classes.screenSecondaryCta}>
                                                        <span>↑</span>
                                                        <span>Show the guaranteed prizes</span>
                                                    </div>
                                                    <div className={classes.screenCtaButton}>
                                                        {values.screen_config?.no_entry?.cta || 'Refer a friend'}
                                                    </div>
                                                    <div className={classes.screenFooterText}>
                                                        {values.screen_config?.no_entry?.footer || 'All prizes overpay your mortgage. Read terms.'}
                                                    </div>
                                                </div>
                                            </>
                                        )}

                                        {/* ACTIVE ENTRY, PENDING CLAIM, PRIZE CLAIMED - Stats Row Layout */}
                                        {selectedScreenVariation !== 'no_entry' && (
                                            <>
                                                {/* Stats Row at Top */}
                                                <div className={classes.screenStatsRow}>
                                                    <div className={classes.screenStatBox}>
                                                        <span className={classes.screenStatLabel}>New referrals</span>
                                                        <div className={classes.screenStatValue}>
                                                            <span role="img" aria-label="person">👤</span>
                                                            <span>1 ▾</span>
                                                        </div>
                                                        <span className={classes.screenPastReferrals}>0 past referrals</span>
                                                    </div>
                                                    <div className={classes.screenStatBox} style={{ alignItems: 'flex-end' }}>
                                                        <span className={classes.screenStatLabel}>Prizes to-date</span>
                                                        <div className={classes.screenStatValueLight}>
                                                            £{selectedScreenVariation === 'prize_claimed' ? '500.00' : '0.00'}
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Chest with Coins Background */}
                                                <div className={classes.screenChestSection}>
                                                    <img src="/prize-chest.svg" alt="Prize Chest" className={classes.screenChestImage} />
                                                </div>

                                                {/* Main Content - Below Chest */}
                                                <div className={classes.screenMainContent}>
                                                    {/* Title */}
                                                    <div className={classes.screenTitle}>
                                                        {selectedScreenVariation === 'active_entry' && (values.screen_config?.active_entry?.title || "You're in! Draw in:")}
                                                        {selectedScreenVariation === 'pending_claim' && (values.screen_config?.pending_claim?.title || 'The results are in!')}
                                                        {selectedScreenVariation === 'prize_claimed' && (values.screen_config?.claimed?.title || 'You won £500!').replace('{amount}', '£500')}
                                                    </div>

                                                    {/* Title 2 - continuation of title, no gap */}
                                                    {selectedScreenVariation === 'active_entry' && values.screen_config?.active_entry?.title2 && (
                                                        <div className={classes.screenTitle} style={{ marginTop: -4 }}>
                                                            {values.screen_config.active_entry.title2.replace('{tickets}', '3')}
                                                        </div>
                                                    )}
                                                    {selectedScreenVariation === 'pending_claim' && values.screen_config?.pending_claim?.title2 && (
                                                        <div className={classes.screenTitle} style={{ marginTop: -4 }}>
                                                            {values.screen_config.pending_claim.title2}
                                                        </div>
                                                    )}
                                                    {selectedScreenVariation === 'prize_claimed' && values.screen_config?.claimed?.title2 && (
                                                        <div className={classes.screenTitle} style={{ marginTop: -4 }}>
                                                            {values.screen_config.claimed.title2}
                                                        </div>
                                                    )}

                                                    {/* Subtitle */}
                                                    <div className={classes.screenSubtitle}>
                                                        {selectedScreenVariation === 'active_entry' && (values.screen_config?.active_entry?.subtitle || 'Last week 12 winners won £1,850')}
                                                        {selectedScreenVariation === 'pending_claim' && (values.screen_config?.pending_claim?.subtitle || 'Tap to reveal your prize')}
                                                        {selectedScreenVariation === 'prize_claimed' && (values.screen_config?.claimed?.subtitle || 'Congrats! Added to your wallet')}
                                                    </div>

                                                    {/* Winner Banner (active_entry only) */}
                                                    {selectedScreenVariation === 'active_entry' && (
                                                        <div className={classes.screenWinnerBanner}>
                                                            <div className={classes.screenWinnerIcon}>£</div>
                                                            <span className={classes.screenWinnerText}>
                                                                {(values.screen_config?.active_entry?.winner_highlight || "Last week's £1k winner did {count} referrals").replace('{count}', '8')}
                                                            </span>
                                                        </div>
                                                    )}

                                                    {/* Countdown (active_entry only) */}
                                                    {selectedScreenVariation === 'active_entry' && (
                                                        <div className={classes.screenCountdownInline}>
                                                            <div className={classes.screenCountdownUnit}>
                                                                <span className={classes.screenCountdownLabel}>DAYS</span>
                                                                <span className={classes.screenCountdownValue}>03</span>
                                                            </div>
                                                            <span className={classes.screenCountdownSeparator}>:</span>
                                                            <div className={classes.screenCountdownUnit}>
                                                                <span className={classes.screenCountdownLabel}>HOURS</span>
                                                                <span className={classes.screenCountdownValue}>13</span>
                                                            </div>
                                                            <span className={classes.screenCountdownSeparator}>:</span>
                                                            <div className={classes.screenCountdownUnit}>
                                                                <span className={classes.screenCountdownLabel}>MINS</span>
                                                                <span className={classes.screenCountdownValue}>59</span>
                                                            </div>
                                                            <span className={classes.screenCountdownSeparator}>:</span>
                                                            <div className={classes.screenCountdownUnit}>
                                                                <span className={classes.screenCountdownLabel}>SECS</span>
                                                                <span className={classes.screenCountdownValue}>54</span>
                                                            </div>
                                                        </div>
                                                    )}

                                                    {/* Boost Badge (prize_claimed only) */}
                                                    {selectedScreenVariation === 'prize_claimed' && (
                                                        <div className={classes.screenBoostBadge}>
                                                            {(values.screen_config?.claimed?.boost_badge || '+{weeks} weeks boost earned').replace('{weeks}', '4')}
                                                        </div>
                                                    )}
                                                </div>

                                                {/* Bottom Section */}
                                                <div className={classes.screenBottomSection}>
                                                    <div className={classes.screenCtaButton}>
                                                        {selectedScreenVariation === 'active_entry' && (values.screen_config?.active_entry?.cta || 'Double your chances')}
                                                        {selectedScreenVariation === 'pending_claim' && (values.screen_config?.pending_claim?.cta || 'Claim now')}
                                                        {selectedScreenVariation === 'prize_claimed' && 'Continue'}
                                                    </div>
                                                    <div className={classes.screenFooterText}>
                                                        {selectedScreenVariation === 'active_entry' && (values.screen_config?.active_entry?.footer || 'You have {tickets} ticket(s)').replace('{tickets}', '3')}
                                                        {selectedScreenVariation === 'pending_claim' && (values.screen_config?.pending_claim?.footer || 'Your result is waiting')}
                                                        {selectedScreenVariation === 'prize_claimed' && (values.screen_config?.claimed?.footer || 'Next draw starts Monday')}
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </AccordionDetails>
                        </Accordion>

                        {/* Featured Winners */}
                        <Accordion
                            expanded={expandedSections.includes("featured")}
                            onChange={handleAccordionChange("featured")}
                            className={classes.accordion}
                        >
                            <AccordionSummary expandIcon={<ExpandMoreIcon />} className={classes.accordionSummary}>
                                <EmojiEventsIcon className={classes.sectionIcon} style={{ color: '#f9a825' }} />
                                <Typography className={classes.sectionTitle}>Featured Winners</Typography>
                                <Typography className={classes.sectionDescription}>Add influencer/manual winners for social proof</Typography>
                            </AccordionSummary>
                            <AccordionDetails className={classes.accordionDetails}>
                                <Typography variant="body2" color="textSecondary" style={{ marginBottom: 16 }}>
                                    Featured winners appear at the top of the winners list in the app. Use this to add influencer earnings or promotional winners.
                                </Typography>

                                {/* Add New Featured Winner */}
                                <div style={{ display: 'flex', gap: 16, alignItems: 'flex-end', marginBottom: 24, padding: 16, backgroundColor: '#f5f5f5', borderRadius: 8 }}>
                                    <TextField
                                        label="Name"
                                        value={newFeaturedName}
                                        onChange={(e) => setNewFeaturedName(e.target.value)}
                                        variant="outlined"
                                        size="small"
                                        placeholder="e.g., Sarah"
                                        style={{ flex: 1 }}
                                    />
                                    <TextField
                                        label="Amount (£)"
                                        value={newFeaturedAmount}
                                        onChange={(e) => setNewFeaturedAmount(e.target.value)}
                                        variant="outlined"
                                        size="small"
                                        placeholder="e.g., 500"
                                        style={{ width: 120 }}
                                        InputProps={{
                                            startAdornment: <InputAdornment position="start">£</InputAdornment>,
                                        }}
                                    />
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={handleAddFeaturedWinner}
                                        disabled={isSavingFeatured || !newFeaturedName.trim() || !newFeaturedAmount.trim()}
                                        startIcon={<AddIcon />}
                                    >
                                        Add
                                    </Button>
                                </div>

                                {/* Featured Winners List */}
                                {featuredWinners.length > 0 ? (
                                    <TableContainer component={Paper} variant="outlined">
                                        <Table size="small">
                                            <TableHead className={classes.tierTableHeader}>
                                                <TableRow>
                                                    <TableCell>#</TableCell>
                                                    <TableCell>Name</TableCell>
                                                    <TableCell align="right">Amount</TableCell>
                                                    <TableCell align="center">Actions</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {featuredWinners.map((winner, index) => (
                                                    <TableRow key={winner.id}>
                                                        <TableCell>{index + 1}</TableCell>
                                                        <TableCell>{winner.name}</TableCell>
                                                        <TableCell align="right">£{Number(winner.prize_amount).toFixed(2)}</TableCell>
                                                        <TableCell align="center">
                                                            <IconButton
                                                                size="small"
                                                                onClick={() => winner.id && handleDeleteFeaturedWinner(winner.id)}
                                                                style={{ color: '#d32f2f' }}
                                                            >
                                                                <DeleteIcon fontSize="small" />
                                                            </IconButton>
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                ) : (
                                    <Typography variant="body2" color="textSecondary" style={{ textAlign: 'center', padding: 24, backgroundColor: '#fafafa', borderRadius: 8 }}>
                                        No featured winners added yet. Add influencer or promotional winners above.
                                    </Typography>
                                )}

                                <Typography variant="caption" color="textSecondary" style={{ display: 'block', marginTop: 16 }}>
                                    <strong>Note:</strong> Featured winners are shown at the top of the winners list in the app's prize draw screen.
                                    They appear before the actual draw winners and are marked with a special flag.
                                </Typography>
                            </AccordionDetails>
                        </Accordion>

                    </div>

                    {/* Tier Edit Dialog */}
                    <Dialog open={tierDialogOpen} onClose={() => setTierDialogOpen(false)} maxWidth="sm" fullWidth>
                        <DialogTitle>{editingTier?.id ? 'Edit Prize Tier' : 'Add Prize Tier'}</DialogTitle>
                        <DialogContent>
                            <div style={{ display: 'grid', gap: 16, paddingTop: 8 }}>
                                <TextField
                                    label="Tier Rank"
                                    inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                                    value={editingTier?.tier_rank ?? ''}
                                    onChange={(e) => {
                                        const value = e.target?.value ?? '';
                                        const numValue = value === '' ? '' : parseInt(value);
                                        setEditingTier(prev => prev ? { ...prev, tier_rank: numValue as any } : prev);
                                    }}
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                />
                                <TextField
                                    label="Display Label"
                                    value={editingTier?.display_label ?? ''}
                                    onChange={(e) => {
                                        const value = e.target?.value ?? '';
                                        setEditingTier(prev => prev ? { ...prev, display_label: value } : prev);
                                    }}
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                    placeholder="e.g., Grand Prize"
                                />
                                <TextField
                                    label="Prize Amount (£)"
                                    inputProps={{ inputMode: 'decimal', pattern: '[0-9]*\\.?[0-9]*' }}
                                    value={editingTier?.prize_amount ?? ''}
                                    onChange={(e) => {
                                        const value = e.target?.value ?? '';
                                        const numValue = value === '' ? '' : parseFloat(value);
                                        setEditingTier(prev => prev ? { ...prev, prize_amount: numValue as any } : prev);
                                    }}
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                />
                                <TextField
                                    label="Winner Count"
                                    inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                                    value={editingTier?.winner_count ?? ''}
                                    onChange={(e) => {
                                        const value = e.target?.value ?? '';
                                        const numValue = value === '' ? '' : parseInt(value);
                                        setEditingTier(prev => prev ? { ...prev, winner_count: numValue as any } : prev);
                                    }}
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                />
                                <TextField
                                    label="Min Tickets for Eligibility"
                                    inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                                    value={editingTier?.min_tickets_for_eligibility ?? ''}
                                    onChange={(e) => {
                                        const value = e.target?.value ?? '';
                                        const numValue = value === '' ? '' : parseInt(value);
                                        setEditingTier(prev => prev ? { ...prev, min_tickets_for_eligibility: numValue as any } : prev);
                                    }}
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                />
                                <TextField
                                    label="Ticket Weight Multiplier"
                                    inputProps={{ inputMode: 'decimal', pattern: '[0-9]*\\.?[0-9]*', step: '0.1' }}
                                    value={editingTier?.ticket_weight_multiplier ?? ''}
                                    onChange={(e) => {
                                        const value = e.target?.value ?? '';
                                        const numValue = value === '' ? '' : parseFloat(value);
                                        setEditingTier(prev => prev ? { ...prev, ticket_weight_multiplier: numValue as any } : prev);
                                    }}
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                />
                                <TextField
                                    label="Display Color"
                                    type="color"
                                    value={editingTier?.display_color || '#4CAF50'}
                                    onChange={(e) => {
                                        const value = e.target?.value ?? '#4CAF50';
                                        setEditingTier(prev => prev ? { ...prev, display_color: value } : prev);
                                    }}
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                />
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={editingTier?.is_top_prize || false}
                                            onChange={(e) => {
                                                const checked = e.target?.checked ?? false;
                                                setEditingTier(prev => prev ? { ...prev, is_top_prize: checked } : prev);
                                            }}
                                            color="primary"
                                        />
                                    }
                                    label="Top Prize (subject to monthly limit)"
                                />
                            </div>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => setTierDialogOpen(false)}>Cancel</Button>
                            <Button
                                onClick={() => editingTier && handleTierSave(editingTier)}
                                color="primary"
                                variant="contained"
                            >
                                Save
                            </Button>
                        </DialogActions>
                    </Dialog>

                    {/* Adjust Winner Dialog */}
                    <Dialog
                        open={adjustDialogOpen}
                        onClose={() => { setAdjustDialogOpen(false); setAdjustNewPrize(''); }}
                        maxWidth="sm"
                        fullWidth
                    >
                        <DialogTitle>
                            Adjust Prize Winner
                        </DialogTitle>
                        <DialogContent>
                            {adjustingResult && (
                                <div style={{ display: 'flex', flexDirection: 'column', gap: 16, paddingTop: 8 }}>
                                    <div style={{ backgroundColor: '#f5f5f5', padding: 16, borderRadius: 8 }}>
                                        <Typography variant="subtitle2" color="textSecondary">Current Winner</Typography>
                                        <Typography variant="h6">{adjustingResult.userName}</Typography>
                                        <Typography variant="body2">{adjustingResult.userEmail}</Typography>
                                        <Typography variant="body2">
                                            Tickets: {adjustingResult.effectiveTickets} |
                                            Current Prize: £{adjustingResult.prizeAmount}
                                            {adjustingResult.basePrize && adjustingResult.basePrize !== adjustingResult.prizeAmount && ` (base: £${adjustingResult.basePrize})`}
                                        </Typography>
                                    </div>

                                    <FormControl fullWidth variant="outlined" size="small">
                                        <InputLabel>Swap Winner (optional)</InputLabel>
                                        <Select
                                            value={adjustNewUserId || ''}
                                            onChange={(e) => setAdjustNewUserId(e.target.value ? Number(e.target.value) : null)}
                                            label="Swap Winner (optional)"
                                        >
                                            <MenuItem value="">
                                                <em>Keep current winner</em>
                                            </MenuItem>
                                            {allParticipants.map(p => (
                                                <MenuItem key={p.userId} value={p.userId}>
                                                    {p.userName} ({p.userEmail}) - {p.totalTickets} tickets
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>

                                    {isParticipationMode ? (
                                        /* Participation Mode: Simple prize amount input */
                                        <TextField
                                            label="New Prize Amount (£)"
                                            placeholder="Enter new prize amount"
                                            value={adjustNewPrize}
                                            onChange={(e) => setAdjustNewPrize(e.target.value)}
                                            fullWidth
                                            variant="outlined"
                                            size="small"
                                            type="number"
                                            InputProps={{
                                                startAdornment: <span style={{ marginRight: 4 }}>£</span>
                                            }}
                                            helperText={adjustNewPrize
                                                ? `Winner will receive £${adjustNewPrize} (base: £${adjustingResult?.prizeAmount})`
                                                : 'Leave empty to keep base prize'
                                            }
                                        />
                                    ) : (
                                        /* Lottery Mode: Tier dropdown + custom prize */
                                        <>
                                            <FormControl fullWidth variant="outlined" size="small">
                                                <InputLabel>New Tier</InputLabel>
                                                <Select
                                                    value={adjustNewTier}
                                                    onChange={(e) => setAdjustNewTier(Number(e.target.value))}
                                                    label="New Tier"
                                                >
                                                    <MenuItem value={0}>
                                                        <em>Keep current tier</em>
                                                    </MenuItem>
                                                    {prizeTiers.map(tier => (
                                                        <MenuItem key={tier.id} value={tier.tier_rank}>
                                                            {tier.display_label} - £{tier.prize_amount}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                            <TextField
                                                label="Custom Prize Amount (£)"
                                                placeholder="Leave empty to use tier default"
                                                value={adjustNewPrize}
                                                onChange={(e) => setAdjustNewPrize(e.target.value)}
                                                fullWidth
                                                variant="outlined"
                                                size="small"
                                                type="number"
                                                InputProps={{
                                                    startAdornment: <span style={{ marginRight: 4 }}>£</span>
                                                }}
                                                helperText={adjustNewPrize ? `Winner will receive £${adjustNewPrize}` : 'Uses tier default prize amount'}
                                            />
                                        </>
                                    )}

                                    <TextField
                                        label="Reason for adjustment *"
                                        placeholder="e.g., Duplicate entry, Fraud detected, Already won this month"
                                        value={adjustReason}
                                        onChange={(e) => setAdjustReason(e.target.value)}
                                        fullWidth
                                        multiline
                                        rows={2}
                                        variant="outlined"
                                        size="small"
                                        required
                                    />

                                    <Typography variant="caption" color="textSecondary">
                                        Note: This adjustment will be logged in the audit trail. The winner will receive
                                        the adjusted prize amount when the draw is confirmed.
                                    </Typography>
                                </div>
                            )}
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => { setAdjustDialogOpen(false); setAdjustNewPrize(''); }}>Cancel</Button>
                            <Button
                                onClick={handleApplyAdjustment}
                                color="primary"
                                variant="contained"
                                disabled={!adjustReason.trim()}
                            >
                                Apply Adjustment
                            </Button>
                        </DialogActions>
                    </Dialog>

                    {/* Archive Modal */}
                    <Dialog
                        open={archiveModalOpen}
                        onClose={() => setArchiveModalOpen(false)}
                        maxWidth="lg"
                        fullWidth
                    >
                        <DialogTitle>
                            Prize Draw Archive
                        </DialogTitle>
                        <DialogContent dividers>
                            <div style={{ display: 'flex', gap: 24, minHeight: 400 }}>
                                {/* Week List */}
                                <div style={{ width: 280, borderRight: '1px solid #e0e0e0', paddingRight: 16 }}>
                                    <Typography variant="subtitle2" color="textSecondary" style={{ marginBottom: 8 }}>
                                        All Weeks ({archivedWeeks.length})
                                    </Typography>
                                    <div style={{ maxHeight: 400, overflowY: 'auto' }}>
                                        {archivedWeeks.map(week => (
                                            <div
                                                key={week.id}
                                                onClick={() => handleSelectArchiveWeek(week)}
                                                style={{
                                                    padding: '12px',
                                                    marginBottom: 8,
                                                    borderRadius: 8,
                                                    cursor: 'pointer',
                                                    backgroundColor: selectedArchiveWeek?.id === week.id ? '#e3f2fd' : '#f5f5f5',
                                                    border: selectedArchiveWeek?.id === week.id ? '2px solid #1976d2' : '1px solid #e0e0e0'
                                                }}
                                            >
                                                <Typography variant="subtitle2">
                                                    Week {week.week_number}, {week.year}
                                                </Typography>
                                                <Typography variant="caption" color="textSecondary">
                                                    {new Date(week.start_date).toLocaleDateString()} - {new Date(week.end_date).toLocaleDateString()}
                                                </Typography>
                                                <div style={{ marginTop: 4 }}>
                                                    <span style={{
                                                        padding: '2px 6px',
                                                        borderRadius: 4,
                                                        fontSize: 10,
                                                        backgroundColor: getStatusColor(week.status || 'active').bg,
                                                        color: getStatusColor(week.status || 'active').color
                                                    }}>
                                                        {String(week.status || 'active').replace(/_/g, ' ').toUpperCase()}
                                                    </span>
                                                </div>
                                                <Typography variant="caption" style={{ display: 'block', marginTop: 4 }}>
                                                    {week.total_participants || 0} participants · £{parseFloat(String(week.total_spent || 0)).toFixed(0)} spent
                                                </Typography>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                {/* Week Details */}
                                <div style={{ flex: 1 }}>
                                    {selectedArchiveWeek ? (
                                        <>
                                            <div style={{ marginBottom: 16 }}>
                                                <Typography variant="h6">
                                                    Week {selectedArchiveWeek.week_number}, {selectedArchiveWeek.year}
                                                </Typography>
                                                <Typography variant="body2" color="textSecondary">
                                                    {new Date(selectedArchiveWeek.start_date).toLocaleDateString()} - {new Date(selectedArchiveWeek.end_date).toLocaleDateString()}
                                                </Typography>
                                            </div>

                                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 12, marginBottom: 16 }}>
                                                <div style={{ padding: 12, backgroundColor: '#f5f5f5', borderRadius: 8, textAlign: 'center' }}>
                                                    <Typography variant="h6">{selectedArchiveWeek.total_participants || 0}</Typography>
                                                    <Typography variant="caption">Participants</Typography>
                                                </div>
                                                <div style={{ padding: 12, backgroundColor: '#f5f5f5', borderRadius: 8, textAlign: 'center' }}>
                                                    <Typography variant="h6">{selectedArchiveWeek.total_entries || 0}</Typography>
                                                    <Typography variant="caption">Tickets</Typography>
                                                </div>
                                                <div style={{ padding: 12, backgroundColor: '#f5f5f5', borderRadius: 8, textAlign: 'center' }}>
                                                    <Typography variant="h6">£{parseFloat(String(selectedArchiveWeek.total_budget || 0)).toFixed(0)}</Typography>
                                                    <Typography variant="caption">Budget</Typography>
                                                </div>
                                                <div style={{ padding: 12, backgroundColor: '#f5f5f5', borderRadius: 8, textAlign: 'center' }}>
                                                    <Typography variant="h6">£{parseFloat(String(selectedArchiveWeek.total_spent || 0)).toFixed(0)}</Typography>
                                                    <Typography variant="caption">Spent</Typography>
                                                </div>
                                            </div>

                                            <Typography variant="subtitle2" style={{ marginBottom: 8 }}>
                                                Winners ({archiveResults.length})
                                            </Typography>
                                            {archiveResults.length > 0 ? (
                                                <TableContainer component={Paper} style={{ maxHeight: 300 }}>
                                                    <Table size="small" stickyHeader>
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell>#</TableCell>
                                                                <TableCell>User</TableCell>
                                                                <TableCell>Email</TableCell>
                                                                <TableCell>Tier</TableCell>
                                                                <TableCell>Prize</TableCell>
                                                                <TableCell>Boost</TableCell>
                                                                <TableCell>Status</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {archiveResults.map((result, idx) => (
                                                                <TableRow key={result.userId}>
                                                                    <TableCell>{idx + 1}</TableCell>
                                                                    <TableCell>{result.userName}</TableCell>
                                                                    <TableCell>{result.userEmail}</TableCell>
                                                                    <TableCell>
                                                                        <span style={{
                                                                            padding: '2px 8px',
                                                                            borderRadius: 12,
                                                                            fontSize: 12,
                                                                            backgroundColor: (result.tierRank || 0) <= 3 ? '#fff3e0' : '#e3f2fd',
                                                                            color: (result.tierRank || 0) <= 3 ? '#e65100' : '#1565c0'
                                                                        }}>
                                                                            {result.tierLabel || `#${result.rank || '-'}`}
                                                                        </span>
                                                                    </TableCell>
                                                                    <TableCell style={{ fontWeight: 600 }}>£{result.prizeAmount}</TableCell>
                                                                    <TableCell>+{result.boostWeeks}w</TableCell>
                                                                    <TableCell>
                                                                        <span style={{
                                                                            padding: '2px 8px',
                                                                            borderRadius: 12,
                                                                            fontSize: 11,
                                                                            fontWeight: 500,
                                                                            backgroundColor: result.claimStatus === 'claimed' ? '#e8f5e9' : '#fff8e1',
                                                                            color: result.claimStatus === 'claimed' ? '#2e7d32' : '#f57c00'
                                                                        }}>
                                                                            {result.claimStatus === 'claimed' ? 'Claimed' : 'Pending'}
                                                                        </span>
                                                                    </TableCell>
                                                                </TableRow>
                                                            ))}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            ) : (
                                                <Typography variant="body2" color="textSecondary">
                                                    No winners found for this week.
                                                </Typography>
                                            )}
                                        </>
                                    ) : (
                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                                            <Typography variant="body1" color="textSecondary">
                                                Select a week to view details
                                            </Typography>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => setArchiveModalOpen(false)}>Close</Button>
                        </DialogActions>
                    </Dialog>

                    <Notification />
                </form>
            )}
        </Form>
    );
};

export default PrizeDrawConfig;
